// This client was generated by Platformatic from an OpenAPI specification.

import type { SpendeskApi } from './spendesk-api-types';
import type * as Types from './spendesk-api-types';

// The base URL for the API. This can be overridden by calling `setBaseUrl`.
let baseUrl = '';
// The default headers to send within each request. This can be overridden by calling `setDefaultHeaders`.
let defaultHeaders = {};
// The additional parameters you want to pass to the `fetch` instance.
let defaultFetchParams = {};
const defaultJsonType = { 'Content-type': 'application/json; charset=utf-8' };

function sanitizeUrl(url: string): string {
  if (url.endsWith('/')) {
    return url.slice(0, -1);
  } else {
    return url;
  }
}
export const setBaseUrl = (newUrl: string): void => {
  baseUrl = sanitizeUrl(newUrl);
};

export const setDefaultHeaders = (headers: object): void => {
  defaultHeaders = headers;
};

export const setDefaultFetchParams = (fetchParams: RequestInit): void => {
  defaultFetchParams = fetchParams;
};

type JSON = Record<string, unknown>;
/* @ts-ignore - potential unused variable */
function headersToJSON(headers: Headers): JSON {
  const output: JSON = {};
  headers.forEach((value, key) => {
    output[key] = value;
  });
  return output;
}

const _getV2ApiAssetsSuppliersLogo = async (
  url: string,
  request: Types.GetV2ApiAssetsSuppliersLogoRequest,
): Promise<Types.GetV2ApiAssetsSuppliersLogoResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiAssetsSuppliersLogoRequest['query']
  >)[] = ['name'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/assets/suppliers/logo?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiAssetsSuppliersLogo: SpendeskApi['getV2ApiAssetsSuppliersLogo'] =
  async (
    request: Types.GetV2ApiAssetsSuppliersLogoRequest,
  ): Promise<Types.GetV2ApiAssetsSuppliersLogoResponses> => {
    return await _getV2ApiAssetsSuppliersLogo(baseUrl, request);
  };
const _postV2ApiAuthPasswordValidity = async (
  url: string,
  request: Types.PostV2ApiAuthPasswordValidityRequest,
): Promise<Types.PostV2ApiAuthPasswordValidityResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(`${url}/v2/api/auth/password/validity`, {
    method: 'POST',
    body: isFormData ? body : JSON.stringify(body),
    credentials: 'include',
    headers,
    ...defaultFetchParams,
  });

  if (response.status === 204) {
    return {
      statusCode: response.status,
      headers: headersToJSON(response.headers),
      body: undefined,
    };
  }
  const jsonResponses = [400];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 400,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 204 | 400,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiAuthPasswordValidity: SpendeskApi['postV2ApiAuthPasswordValidity'] =
  async (
    request: Types.PostV2ApiAuthPasswordValidityRequest,
  ): Promise<Types.PostV2ApiAuthPasswordValidityResponses> => {
    return await _postV2ApiAuthPasswordValidity(baseUrl, request);
  };
const _postV2ApiAuthUserVerificationValidate = async (
  url: string,
  request: Types.PostV2ApiAuthUserVerificationValidateRequest,
): Promise<Types.PostV2ApiAuthUserVerificationValidateResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/auth/user-verification/validate`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 404];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 404,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 404,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiAuthUserVerificationValidate: SpendeskApi['postV2ApiAuthUserVerificationValidate'] =
  async (
    request: Types.PostV2ApiAuthUserVerificationValidateRequest,
  ): Promise<Types.PostV2ApiAuthUserVerificationValidateResponses> => {
    return await _postV2ApiAuthUserVerificationValidate(baseUrl, request);
  };
const _postV2ApiAuthUserVerificationValidationLinkForwardToPhone = async (
  url: string,
  request: Types.PostV2ApiAuthUserVerificationValidationLinkForwardToPhoneRequest,
): Promise<Types.PostV2ApiAuthUserVerificationValidationLinkForwardToPhoneResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/auth/user-verification/validation-link/forward-to-phone`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 403, 404, 429];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 403 | 404 | 429,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 403 | 404 | 429,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiAuthUserVerificationValidationLinkForwardToPhone: SpendeskApi['postV2ApiAuthUserVerificationValidationLinkForwardToPhone'] =
  async (
    request: Types.PostV2ApiAuthUserVerificationValidationLinkForwardToPhoneRequest,
  ): Promise<Types.PostV2ApiAuthUserVerificationValidationLinkForwardToPhoneResponses> => {
    return await _postV2ApiAuthUserVerificationValidationLinkForwardToPhone(
      baseUrl,
      request,
    );
  };
const _getV2ApiAuthenticationFactors = async (
  url: string,
  request: Types.GetV2ApiAuthenticationFactorsRequest,
): Promise<Types.GetV2ApiAuthenticationFactorsResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(`${url}/v2/api/authentication-factors/`, {
    credentials: 'include',
    headers,
    ...defaultFetchParams,
  });

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiAuthenticationFactors: SpendeskApi['getV2ApiAuthenticationFactors'] =
  async (
    request: Types.GetV2ApiAuthenticationFactorsRequest,
  ): Promise<Types.GetV2ApiAuthenticationFactorsResponses> => {
    return await _getV2ApiAuthenticationFactors(baseUrl, request);
  };
const _postV2ApiAuthenticationFactors = async (
  url: string,
  request: Types.PostV2ApiAuthenticationFactorsRequest,
): Promise<Types.PostV2ApiAuthenticationFactorsResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(`${url}/v2/api/authentication-factors/`, {
    method: 'POST',
    body: isFormData ? body : JSON.stringify(body),
    credentials: 'include',
    headers,
    ...defaultFetchParams,
  });

  const jsonResponses = [201, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 201 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 201 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiAuthenticationFactors: SpendeskApi['postV2ApiAuthenticationFactors'] =
  async (
    request: Types.PostV2ApiAuthenticationFactorsRequest,
  ): Promise<Types.PostV2ApiAuthenticationFactorsResponses> => {
    return await _postV2ApiAuthenticationFactors(baseUrl, request);
  };
const _deleteV2ApiAuthenticationFactorsFactorId = async (
  url: string,
  request: Types.DeleteV2ApiAuthenticationFactorsFactorIdRequest,
): Promise<Types.DeleteV2ApiAuthenticationFactorsFactorIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/authentication-factors/${request.path['factorId']}`,
    {
      method: 'DELETE',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  if (response.status === 204) {
    return {
      statusCode: response.status,
      headers: headersToJSON(response.headers),
      body: undefined,
    };
  }
  const jsonResponses = [400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 204 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const deleteV2ApiAuthenticationFactorsFactorId: SpendeskApi['deleteV2ApiAuthenticationFactorsFactorId'] =
  async (
    request: Types.DeleteV2ApiAuthenticationFactorsFactorIdRequest,
  ): Promise<Types.DeleteV2ApiAuthenticationFactorsFactorIdResponses> => {
    return await _deleteV2ApiAuthenticationFactorsFactorId(baseUrl, request);
  };
const _postV2ApiAuthenticationFactorsFactorIdFinalize = async (
  url: string,
  request: Types.PostV2ApiAuthenticationFactorsFactorIdFinalizeRequest,
): Promise<Types.PostV2ApiAuthenticationFactorsFactorIdFinalizeResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/authentication-factors/${request.path['factorId']}/finalize`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  if (response.status === 204) {
    return {
      statusCode: response.status,
      headers: headersToJSON(response.headers),
      body: undefined,
    };
  }
  const jsonResponses = [400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 204 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiAuthenticationFactorsFactorIdFinalize: SpendeskApi['postV2ApiAuthenticationFactorsFactorIdFinalize'] =
  async (
    request: Types.PostV2ApiAuthenticationFactorsFactorIdFinalizeRequest,
  ): Promise<Types.PostV2ApiAuthenticationFactorsFactorIdFinalizeResponses> => {
    return await _postV2ApiAuthenticationFactorsFactorIdFinalize(
      baseUrl,
      request,
    );
  };
const _postV2ApiAuthenticationOperationsOperationId = async (
  url: string,
  request: Types.PostV2ApiAuthenticationOperationsOperationIdRequest,
): Promise<Types.PostV2ApiAuthenticationOperationsOperationIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/authentication-operations/${request.path['operationId']}`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  if (response.status === 204) {
    return {
      statusCode: response.status,
      headers: headersToJSON(response.headers),
      body: undefined,
    };
  }
  const jsonResponses = [400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 204 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiAuthenticationOperationsOperationId: SpendeskApi['postV2ApiAuthenticationOperationsOperationId'] =
  async (
    request: Types.PostV2ApiAuthenticationOperationsOperationIdRequest,
  ): Promise<Types.PostV2ApiAuthenticationOperationsOperationIdResponses> => {
    return await _postV2ApiAuthenticationOperationsOperationId(
      baseUrl,
      request,
    );
  };
const _postV2ApiCardsPaymentPasswordReset = async (
  url: string,
  request: Types.PostV2ApiCardsPaymentPasswordResetRequest,
): Promise<Types.PostV2ApiCardsPaymentPasswordResetResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(`${url}/v2/api/cards/payment-password/reset`, {
    method: 'POST',
    body: isFormData ? body : JSON.stringify(body),
    credentials: 'include',
    headers,
    ...defaultFetchParams,
  });

  const jsonResponses = [200, 400, 401, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCardsPaymentPasswordReset: SpendeskApi['postV2ApiCardsPaymentPasswordReset'] =
  async (
    request: Types.PostV2ApiCardsPaymentPasswordResetRequest,
  ): Promise<Types.PostV2ApiCardsPaymentPasswordResetResponses> => {
    return await _postV2ApiCardsPaymentPasswordReset(baseUrl, request);
  };
const _postV2ApiCardsPaymentPasswordShow = async (
  url: string,
  request: Types.PostV2ApiCardsPaymentPasswordShowRequest,
): Promise<Types.PostV2ApiCardsPaymentPasswordShowResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(`${url}/v2/api/cards/payment-password/show`, {
    method: 'POST',
    body: isFormData ? body : JSON.stringify(body),
    credentials: 'include',
    headers,
    ...defaultFetchParams,
  });

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCardsPaymentPasswordShow: SpendeskApi['postV2ApiCardsPaymentPasswordShow'] =
  async (
    request: Types.PostV2ApiCardsPaymentPasswordShowRequest,
  ): Promise<Types.PostV2ApiCardsPaymentPasswordShowResponses> => {
    return await _postV2ApiCardsPaymentPasswordShow(baseUrl, request);
  };
const _postV2ApiCardsPaymentPasswordProcedureId = async (
  url: string,
  request: Types.PostV2ApiCardsPaymentPasswordProcedureIdRequest,
): Promise<Types.PostV2ApiCardsPaymentPasswordProcedureIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/cards/payment-password/${request.path['procedureId']}`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCardsPaymentPasswordProcedureId: SpendeskApi['postV2ApiCardsPaymentPasswordProcedureId'] =
  async (
    request: Types.PostV2ApiCardsPaymentPasswordProcedureIdRequest,
  ): Promise<Types.PostV2ApiCardsPaymentPasswordProcedureIdResponses> => {
    return await _postV2ApiCardsPaymentPasswordProcedureId(baseUrl, request);
  };
const _getV2ApiCurrencies = async (
  url: string,
  request: Types.GetV2ApiCurrenciesRequest,
): Promise<Types.GetV2ApiCurrenciesResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(`${url}/v2/api/currencies`, {
    credentials: 'include',
    headers,
    ...defaultFetchParams,
  });

  const jsonResponses = [200];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCurrencies: SpendeskApi['getV2ApiCurrencies'] = async (
  request: Types.GetV2ApiCurrenciesRequest,
): Promise<Types.GetV2ApiCurrenciesResponses> => {
  return await _getV2ApiCurrencies(baseUrl, request);
};
const _getV2ApiExpenseBeneficiaries = async (
  url: string,
  request: Types.GetV2ApiExpenseBeneficiariesRequest,
): Promise<Types.GetV2ApiExpenseBeneficiariesResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiExpenseBeneficiariesRequest['query']
  >)[] = ['input', 'limit'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/expense-beneficiaries?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiExpenseBeneficiaries: SpendeskApi['getV2ApiExpenseBeneficiaries'] =
  async (
    request: Types.GetV2ApiExpenseBeneficiariesRequest,
  ): Promise<Types.GetV2ApiExpenseBeneficiariesResponses> => {
    return await _getV2ApiExpenseBeneficiaries(baseUrl, request);
  };
const _getV2ApiGeoPlaces = async (
  url: string,
  request: Types.GetV2ApiGeoPlacesRequest,
): Promise<Types.GetV2ApiGeoPlacesResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiGeoPlacesRequest['query']
  >)[] = ['searchText', 'requesterCountryCode', 'types', 'language'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/geo/places?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiGeoPlaces: SpendeskApi['getV2ApiGeoPlaces'] = async (
  request: Types.GetV2ApiGeoPlacesRequest,
): Promise<Types.GetV2ApiGeoPlacesResponses> => {
  return await _getV2ApiGeoPlaces(baseUrl, request);
};
const _getV2ApiScaAuthenticationFactors = async (
  url: string,
  request: Types.GetV2ApiScaAuthenticationFactorsRequest,
): Promise<Types.GetV2ApiScaAuthenticationFactorsResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };
  if (request.headers && request.headers['authorization'] !== undefined) {
    headers['authorization'] = request.headers['authorization'];
    delete request.headers['authorization'];
  }

  const response = await fetch(`${url}/v2/api/sca/authentication-factors/`, {
    credentials: 'include',
    headers,
    ...defaultFetchParams,
  });

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiScaAuthenticationFactors: SpendeskApi['getV2ApiScaAuthenticationFactors'] =
  async (
    request: Types.GetV2ApiScaAuthenticationFactorsRequest,
  ): Promise<Types.GetV2ApiScaAuthenticationFactorsResponses> => {
    return await _getV2ApiScaAuthenticationFactors(baseUrl, request);
  };
const _postV2ApiScaAuthenticationOperationsValidateProcedureWithTotp = async (
  url: string,
  request: Types.PostV2ApiScaAuthenticationOperationsValidateProcedureWithTotpRequest,
): Promise<Types.PostV2ApiScaAuthenticationOperationsValidateProcedureWithTotpResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };
  if (request.headers && request.headers['authorization'] !== undefined) {
    headers['authorization'] = request.headers['authorization'];
    delete request.headers['authorization'];
  }

  const response = await fetch(
    `${url}/v2/api/sca/authentication-operations/validate-procedure-with-totp`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  if (response.status === 204) {
    return {
      statusCode: response.status,
      headers: headersToJSON(response.headers),
      body: undefined,
    };
  }
  const jsonResponses = [400, 401, 404, 422, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 400 | 401 | 404 | 422 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 204 | 400 | 401 | 404 | 422 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiScaAuthenticationOperationsValidateProcedureWithTotp: SpendeskApi['postV2ApiScaAuthenticationOperationsValidateProcedureWithTotp'] =
  async (
    request: Types.PostV2ApiScaAuthenticationOperationsValidateProcedureWithTotpRequest,
  ): Promise<Types.PostV2ApiScaAuthenticationOperationsValidateProcedureWithTotpResponses> => {
    return await _postV2ApiScaAuthenticationOperationsValidateProcedureWithTotp(
      baseUrl,
      request,
    );
  };
const _postV2ApiTrustedDeviceValidate = async (
  url: string,
  request: Types.PostV2ApiTrustedDeviceValidateRequest,
): Promise<Types.PostV2ApiTrustedDeviceValidateResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(`${url}/v2/api/trusted-device/validate`, {
    method: 'POST',
    body: isFormData ? body : JSON.stringify(body),
    credentials: 'include',
    headers,
    ...defaultFetchParams,
  });

  if (response.status === 204) {
    return {
      statusCode: response.status,
      headers: headersToJSON(response.headers),
      body: undefined,
    };
  }
  const jsonResponses = [400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 204 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiTrustedDeviceValidate: SpendeskApi['postV2ApiTrustedDeviceValidate'] =
  async (
    request: Types.PostV2ApiTrustedDeviceValidateRequest,
  ): Promise<Types.PostV2ApiTrustedDeviceValidateResponses> => {
    return await _postV2ApiTrustedDeviceValidate(baseUrl, request);
  };
const _deleteV2ApiTrustedDeviceTrustedDeviceId = async (
  url: string,
  request: Types.DeleteV2ApiTrustedDeviceTrustedDeviceIdRequest,
): Promise<Types.DeleteV2ApiTrustedDeviceTrustedDeviceIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/trusted-device/${request.path['trustedDeviceId']}`,
    {
      method: 'DELETE',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  if (response.status === 204) {
    return {
      statusCode: response.status,
      headers: headersToJSON(response.headers),
      body: undefined,
    };
  }
  const jsonResponses = [400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 204 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const deleteV2ApiTrustedDeviceTrustedDeviceId: SpendeskApi['deleteV2ApiTrustedDeviceTrustedDeviceId'] =
  async (
    request: Types.DeleteV2ApiTrustedDeviceTrustedDeviceIdRequest,
  ): Promise<Types.DeleteV2ApiTrustedDeviceTrustedDeviceIdResponses> => {
    return await _deleteV2ApiTrustedDeviceTrustedDeviceId(baseUrl, request);
  };
const _getV2ApiTrustedDevices = async (
  url: string,
  request: Types.GetV2ApiTrustedDevicesRequest,
): Promise<Types.GetV2ApiTrustedDevicesResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiTrustedDevicesRequest['query']
  >)[] = ['revoked', 'enrichTrustedDeviceLastConnection'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/trusted-devices?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiTrustedDevices: SpendeskApi['getV2ApiTrustedDevices'] =
  async (
    request: Types.GetV2ApiTrustedDevicesRequest,
  ): Promise<Types.GetV2ApiTrustedDevicesResponses> => {
    return await _getV2ApiTrustedDevices(baseUrl, request);
  };
const _getV2ApiCompanyIdAccountingIntegrationsAccountingSoftware = async (
  url: string,
  request: Types.GetV2ApiCompanyIdAccountingIntegrationsAccountingSoftwareRequest,
): Promise<Types.GetV2ApiCompanyIdAccountingIntegrationsAccountingSoftwareResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/accounting-integrations/accounting-software`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdAccountingIntegrationsAccountingSoftware: SpendeskApi['getV2ApiCompanyIdAccountingIntegrationsAccountingSoftware'] =
  async (
    request: Types.GetV2ApiCompanyIdAccountingIntegrationsAccountingSoftwareRequest,
  ): Promise<Types.GetV2ApiCompanyIdAccountingIntegrationsAccountingSoftwareResponses> => {
    return await _getV2ApiCompanyIdAccountingIntegrationsAccountingSoftware(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFields = async (
  url: string,
  request: Types.GetV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsRequest,
): Promise<Types.GetV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/accounting-integrations/mapping/analytical-fields`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFields: SpendeskApi['getV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFields'] =
  async (
    request: Types.GetV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsRequest,
  ): Promise<Types.GetV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsResponses> => {
    return await _getV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFields(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFields = async (
  url: string,
  request: Types.PostV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsRequest,
): Promise<Types.PostV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/accounting-integrations/mapping/analytical-fields`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFields: SpendeskApi['postV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFields'] =
  async (
    request: Types.PostV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsRequest,
  ): Promise<Types.PostV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsResponses> => {
    return await _postV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFields(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfiguration =
  async (
    url: string,
    request: Types.GetV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfigurationRequest,
  ): Promise<Types.GetV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfigurationResponses> => {
    const headers: HeadersInit = {
      ...defaultHeaders,
    };

    const response = await fetch(
      `${url}/v2/api/${request.path['companyId']}/accounting-integrations/mapping/analytical-fields/configuration`,
      {
        credentials: 'include',
        headers,
        ...defaultFetchParams,
      },
    );

    const jsonResponses = [200, 400, 401, 404, 500];
    if (jsonResponses.includes(response.status)) {
      return {
        statusCode: response.status as 200 | 400 | 401 | 404 | 500,
        headers: headersToJSON(response.headers),
        body: await response.json(),
      };
    }
    const responseType = response.headers
      .get('content-type')
      ?.startsWith('application/json')
      ? 'json'
      : 'text';
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response[responseType](),
    };
  };

export const getV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfiguration: SpendeskApi['getV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfiguration'] =
  async (
    request: Types.GetV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfigurationRequest,
  ): Promise<Types.GetV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfigurationResponses> => {
    return await _getV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfiguration(
      baseUrl,
      request,
    );
  };
const _putV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfiguration =
  async (
    url: string,
    request: Types.PutV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfigurationRequest,
  ): Promise<Types.PutV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfigurationResponses> => {
    const body = 'body' in request ? request.body : undefined;
    const isFormData = body instanceof FormData;
    const headers: HeadersInit = {
      ...defaultHeaders,
      ...(isFormData || body === undefined ? {} : defaultJsonType),
    };

    const response = await fetch(
      `${url}/v2/api/${request.path['companyId']}/accounting-integrations/mapping/analytical-fields/configuration`,
      {
        method: 'PUT',
        body: isFormData ? body : JSON.stringify(body),
        credentials: 'include',
        headers,
        ...defaultFetchParams,
      },
    );

    const jsonResponses = [200, 400, 401, 404, 500];
    if (jsonResponses.includes(response.status)) {
      return {
        statusCode: response.status as 200 | 400 | 401 | 404 | 500,
        headers: headersToJSON(response.headers),
        body: await response.json(),
      };
    }
    const responseType = response.headers
      .get('content-type')
      ?.startsWith('application/json')
      ? 'json'
      : 'text';
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response[responseType](),
    };
  };

export const putV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfiguration: SpendeskApi['putV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfiguration'] =
  async (
    request: Types.PutV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfigurationRequest,
  ): Promise<Types.PutV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfigurationResponses> => {
    return await _putV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfiguration(
      baseUrl,
      request,
    );
  };
const _putV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsFieldId =
  async (
    url: string,
    request: Types.PutV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsFieldIdRequest,
  ): Promise<Types.PutV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsFieldIdResponses> => {
    const body = 'body' in request ? request.body : undefined;
    const isFormData = body instanceof FormData;
    const headers: HeadersInit = {
      ...defaultHeaders,
      ...(isFormData || body === undefined ? {} : defaultJsonType),
    };

    const response = await fetch(
      `${url}/v2/api/${request.path['companyId']}/accounting-integrations/mapping/analytical-fields/${request.path['fieldId']}`,
      {
        method: 'PUT',
        body: isFormData ? body : JSON.stringify(body),
        credentials: 'include',
        headers,
        ...defaultFetchParams,
      },
    );

    const jsonResponses = [200, 400, 401, 404, 500];
    if (jsonResponses.includes(response.status)) {
      return {
        statusCode: response.status as 200 | 400 | 401 | 404 | 500,
        headers: headersToJSON(response.headers),
        body: await response.json(),
      };
    }
    const responseType = response.headers
      .get('content-type')
      ?.startsWith('application/json')
      ? 'json'
      : 'text';
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response[responseType](),
    };
  };

export const putV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsFieldId: SpendeskApi['putV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsFieldId'] =
  async (
    request: Types.PutV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsFieldIdRequest,
  ): Promise<Types.PutV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsFieldIdResponses> => {
    return await _putV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsFieldId(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdAccountingIntegrationsSyncOperations = async (
  url: string,
  request: Types.PostV2ApiCompanyIdAccountingIntegrationsSyncOperationsRequest,
): Promise<Types.PostV2ApiCompanyIdAccountingIntegrationsSyncOperationsResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/accounting-integrations/sync-operations/`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [202, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 202 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 202 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdAccountingIntegrationsSyncOperations: SpendeskApi['postV2ApiCompanyIdAccountingIntegrationsSyncOperations'] =
  async (
    request: Types.PostV2ApiCompanyIdAccountingIntegrationsSyncOperationsRequest,
  ): Promise<Types.PostV2ApiCompanyIdAccountingIntegrationsSyncOperationsResponses> => {
    return await _postV2ApiCompanyIdAccountingIntegrationsSyncOperations(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdAccountingIntegrationsSyncOperationsSyncMode = async (
  url: string,
  request: Types.GetV2ApiCompanyIdAccountingIntegrationsSyncOperationsSyncModeRequest,
): Promise<Types.GetV2ApiCompanyIdAccountingIntegrationsSyncOperationsSyncModeResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/accounting-integrations/sync-operations/${request.path['syncMode']}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdAccountingIntegrationsSyncOperationsSyncMode: SpendeskApi['getV2ApiCompanyIdAccountingIntegrationsSyncOperationsSyncMode'] =
  async (
    request: Types.GetV2ApiCompanyIdAccountingIntegrationsSyncOperationsSyncModeRequest,
  ): Promise<Types.GetV2ApiCompanyIdAccountingIntegrationsSyncOperationsSyncModeResponses> => {
    return await _getV2ApiCompanyIdAccountingIntegrationsSyncOperationsSyncMode(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdAccountingIntegrationsSyncSettings = async (
  url: string,
  request: Types.GetV2ApiCompanyIdAccountingIntegrationsSyncSettingsRequest,
): Promise<Types.GetV2ApiCompanyIdAccountingIntegrationsSyncSettingsResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdAccountingIntegrationsSyncSettingsRequest['query']
  >)[] = ['fieldId'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/accounting-integrations/sync-settings?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdAccountingIntegrationsSyncSettings: SpendeskApi['getV2ApiCompanyIdAccountingIntegrationsSyncSettings'] =
  async (
    request: Types.GetV2ApiCompanyIdAccountingIntegrationsSyncSettingsRequest,
  ): Promise<Types.GetV2ApiCompanyIdAccountingIntegrationsSyncSettingsResponses> => {
    return await _getV2ApiCompanyIdAccountingIntegrationsSyncSettings(
      baseUrl,
      request,
    );
  };
const _deleteV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldId = async (
  url: string,
  request: Types.DeleteV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldIdRequest,
): Promise<Types.DeleteV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/accounting-integrations/sync-settings/${request.path['fieldId']}`,
    {
      method: 'DELETE',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const deleteV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldId: SpendeskApi['deleteV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldId'] =
  async (
    request: Types.DeleteV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldIdRequest,
  ): Promise<Types.DeleteV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldIdResponses> => {
    return await _deleteV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldId(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldId = async (
  url: string,
  request: Types.GetV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldIdRequest,
): Promise<Types.GetV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldIdResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/accounting-integrations/sync-settings/${request.path['fieldId']}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldId: SpendeskApi['getV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldId'] =
  async (
    request: Types.GetV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldIdRequest,
  ): Promise<Types.GetV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldIdResponses> => {
    return await _getV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldId(
      baseUrl,
      request,
    );
  };
const _putV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldId = async (
  url: string,
  request: Types.PutV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldIdRequest,
): Promise<Types.PutV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/accounting-integrations/sync-settings/${request.path['fieldId']}`,
    {
      method: 'PUT',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const putV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldId: SpendeskApi['putV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldId'] =
  async (
    request: Types.PutV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldIdRequest,
  ): Promise<Types.PutV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldIdResponses> => {
    return await _putV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldId(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdApprovalWorkflows = async (
  url: string,
  request: Types.PostV2ApiCompanyIdApprovalWorkflowsRequest,
): Promise<Types.PostV2ApiCompanyIdApprovalWorkflowsResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/approval-workflows/`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 403, 409, 422];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 403 | 409 | 422,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 403 | 409 | 422,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdApprovalWorkflows: SpendeskApi['postV2ApiCompanyIdApprovalWorkflows'] =
  async (
    request: Types.PostV2ApiCompanyIdApprovalWorkflowsRequest,
  ): Promise<Types.PostV2ApiCompanyIdApprovalWorkflowsResponses> => {
    return await _postV2ApiCompanyIdApprovalWorkflows(baseUrl, request);
  };
const _getV2ApiCompanyIdApprovalWorkflowsActive = async (
  url: string,
  request: Types.GetV2ApiCompanyIdApprovalWorkflowsActiveRequest,
): Promise<Types.GetV2ApiCompanyIdApprovalWorkflowsActiveResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/approval-workflows/active`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 403, 404];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 403 | 404,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 403 | 404,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdApprovalWorkflowsActive: SpendeskApi['getV2ApiCompanyIdApprovalWorkflowsActive'] =
  async (
    request: Types.GetV2ApiCompanyIdApprovalWorkflowsActiveRequest,
  ): Promise<Types.GetV2ApiCompanyIdApprovalWorkflowsActiveResponses> => {
    return await _getV2ApiCompanyIdApprovalWorkflowsActive(baseUrl, request);
  };
const _postV2ApiCompanyIdApprovalWorkflowsMigrate = async (
  url: string,
  request: Types.PostV2ApiCompanyIdApprovalWorkflowsMigrateRequest,
): Promise<Types.PostV2ApiCompanyIdApprovalWorkflowsMigrateResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/approval-workflows/migrate`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 403, 409, 422];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 403 | 409 | 422,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 403 | 409 | 422,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdApprovalWorkflowsMigrate: SpendeskApi['postV2ApiCompanyIdApprovalWorkflowsMigrate'] =
  async (
    request: Types.PostV2ApiCompanyIdApprovalWorkflowsMigrateRequest,
  ): Promise<Types.PostV2ApiCompanyIdApprovalWorkflowsMigrateResponses> => {
    return await _postV2ApiCompanyIdApprovalWorkflowsMigrate(baseUrl, request);
  };
const _putV2ApiCompanyIdApprovalWorkflowsWorkflowId = async (
  url: string,
  request: Types.PutV2ApiCompanyIdApprovalWorkflowsWorkflowIdRequest,
): Promise<Types.PutV2ApiCompanyIdApprovalWorkflowsWorkflowIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/approval-workflows/${request.path['workflowId']}`,
    {
      method: 'PUT',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 403, 404, 422];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 403 | 404 | 422,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 403 | 404 | 422,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const putV2ApiCompanyIdApprovalWorkflowsWorkflowId: SpendeskApi['putV2ApiCompanyIdApprovalWorkflowsWorkflowId'] =
  async (
    request: Types.PutV2ApiCompanyIdApprovalWorkflowsWorkflowIdRequest,
  ): Promise<Types.PutV2ApiCompanyIdApprovalWorkflowsWorkflowIdResponses> => {
    return await _putV2ApiCompanyIdApprovalWorkflowsWorkflowId(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdAutomationAiGenerateBudget = async (
  url: string,
  request: Types.PostV2ApiCompanyIdAutomationAiGenerateBudgetRequest,
): Promise<Types.PostV2ApiCompanyIdAutomationAiGenerateBudgetResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/automation-ai/generate-budget`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdAutomationAiGenerateBudget: SpendeskApi['postV2ApiCompanyIdAutomationAiGenerateBudget'] =
  async (
    request: Types.PostV2ApiCompanyIdAutomationAiGenerateBudgetRequest,
  ): Promise<Types.PostV2ApiCompanyIdAutomationAiGenerateBudgetResponses> => {
    return await _postV2ApiCompanyIdAutomationAiGenerateBudget(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdBookkeepingDownloadId = async (
  url: string,
  request: Types.GetV2ApiCompanyIdBookkeepingDownloadIdRequest,
): Promise<Types.GetV2ApiCompanyIdBookkeepingDownloadIdResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/bookkeeping/download/${request.path['id']}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdBookkeepingDownloadId: SpendeskApi['getV2ApiCompanyIdBookkeepingDownloadId'] =
  async (
    request: Types.GetV2ApiCompanyIdBookkeepingDownloadIdRequest,
  ): Promise<Types.GetV2ApiCompanyIdBookkeepingDownloadIdResponses> => {
    return await _getV2ApiCompanyIdBookkeepingDownloadId(baseUrl, request);
  };
const _getV2ApiCompanyIdBookkeepingPayablesInboxVersion = async (
  url: string,
  request: Types.GetV2ApiCompanyIdBookkeepingPayablesInboxVersionRequest,
): Promise<Types.GetV2ApiCompanyIdBookkeepingPayablesInboxVersionResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/bookkeeping/payables-inbox-version`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdBookkeepingPayablesInboxVersion: SpendeskApi['getV2ApiCompanyIdBookkeepingPayablesInboxVersion'] =
  async (
    request: Types.GetV2ApiCompanyIdBookkeepingPayablesInboxVersionRequest,
  ): Promise<Types.GetV2ApiCompanyIdBookkeepingPayablesInboxVersionResponses> => {
    return await _getV2ApiCompanyIdBookkeepingPayablesInboxVersion(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdBookkeepingSpainClosurePeriods = async (
  url: string,
  request: Types.GetV2ApiCompanyIdBookkeepingSpainClosurePeriodsRequest,
): Promise<Types.GetV2ApiCompanyIdBookkeepingSpainClosurePeriodsResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdBookkeepingSpainClosurePeriodsRequest['query']
  >)[] = ['state', 'limit'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/bookkeeping/spain-closure-periods?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdBookkeepingSpainClosurePeriods: SpendeskApi['getV2ApiCompanyIdBookkeepingSpainClosurePeriods'] =
  async (
    request: Types.GetV2ApiCompanyIdBookkeepingSpainClosurePeriodsRequest,
  ): Promise<Types.GetV2ApiCompanyIdBookkeepingSpainClosurePeriodsResponses> => {
    return await _getV2ApiCompanyIdBookkeepingSpainClosurePeriods(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdBookkeepingSpainClosurePeriods = async (
  url: string,
  request: Types.PostV2ApiCompanyIdBookkeepingSpainClosurePeriodsRequest,
): Promise<Types.PostV2ApiCompanyIdBookkeepingSpainClosurePeriodsResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/bookkeeping/spain-closure-periods`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 409, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 409 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 409 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdBookkeepingSpainClosurePeriods: SpendeskApi['postV2ApiCompanyIdBookkeepingSpainClosurePeriods'] =
  async (
    request: Types.PostV2ApiCompanyIdBookkeepingSpainClosurePeriodsRequest,
  ): Promise<Types.PostV2ApiCompanyIdBookkeepingSpainClosurePeriodsResponses> => {
    return await _postV2ApiCompanyIdBookkeepingSpainClosurePeriods(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdBookkeepingSpainClosurePeriodsPeriodIdDownloadUrl =
  async (
    url: string,
    request: Types.GetV2ApiCompanyIdBookkeepingSpainClosurePeriodsPeriodIdDownloadUrlRequest,
  ): Promise<Types.GetV2ApiCompanyIdBookkeepingSpainClosurePeriodsPeriodIdDownloadUrlResponses> => {
    const headers: HeadersInit = {
      ...defaultHeaders,
    };

    const response = await fetch(
      `${url}/v2/api/${request.path['companyId']}/bookkeeping/spain-closure-periods/${request.path['periodId']}/download-url`,
      {
        credentials: 'include',
        headers,
        ...defaultFetchParams,
      },
    );

    const jsonResponses = [200, 400, 401, 404, 500];
    if (jsonResponses.includes(response.status)) {
      return {
        statusCode: response.status as 200 | 400 | 401 | 404 | 500,
        headers: headersToJSON(response.headers),
        body: await response.json(),
      };
    }
    const responseType = response.headers
      .get('content-type')
      ?.startsWith('application/json')
      ? 'json'
      : 'text';
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response[responseType](),
    };
  };

export const getV2ApiCompanyIdBookkeepingSpainClosurePeriodsPeriodIdDownloadUrl: SpendeskApi['getV2ApiCompanyIdBookkeepingSpainClosurePeriodsPeriodIdDownloadUrl'] =
  async (
    request: Types.GetV2ApiCompanyIdBookkeepingSpainClosurePeriodsPeriodIdDownloadUrlRequest,
  ): Promise<Types.GetV2ApiCompanyIdBookkeepingSpainClosurePeriodsPeriodIdDownloadUrlResponses> => {
    return await _getV2ApiCompanyIdBookkeepingSpainClosurePeriodsPeriodIdDownloadUrl(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdBookkeepingSpainClosurePeriodsPeriodIdRetry = async (
  url: string,
  request: Types.PostV2ApiCompanyIdBookkeepingSpainClosurePeriodsPeriodIdRetryRequest,
): Promise<Types.PostV2ApiCompanyIdBookkeepingSpainClosurePeriodsPeriodIdRetryResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/bookkeeping/spain-closure-periods/${request.path['periodId']}/retry`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdBookkeepingSpainClosurePeriodsPeriodIdRetry: SpendeskApi['postV2ApiCompanyIdBookkeepingSpainClosurePeriodsPeriodIdRetry'] =
  async (
    request: Types.PostV2ApiCompanyIdBookkeepingSpainClosurePeriodsPeriodIdRetryRequest,
  ): Promise<Types.PostV2ApiCompanyIdBookkeepingSpainClosurePeriodsPeriodIdRetryResponses> => {
    return await _postV2ApiCompanyIdBookkeepingSpainClosurePeriodsPeriodIdRetry(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdBudgetDefinitions = async (
  url: string,
  request: Types.GetV2ApiCompanyIdBudgetDefinitionsRequest,
): Promise<Types.GetV2ApiCompanyIdBudgetDefinitionsResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/budget-definitions/`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 403, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 403 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 403 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdBudgetDefinitions: SpendeskApi['getV2ApiCompanyIdBudgetDefinitions'] =
  async (
    request: Types.GetV2ApiCompanyIdBudgetDefinitionsRequest,
  ): Promise<Types.GetV2ApiCompanyIdBudgetDefinitionsResponses> => {
    return await _getV2ApiCompanyIdBudgetDefinitions(baseUrl, request);
  };
const _postV2ApiCompanyIdBudgetDefinitions = async (
  url: string,
  request: Types.PostV2ApiCompanyIdBudgetDefinitionsRequest,
): Promise<Types.PostV2ApiCompanyIdBudgetDefinitionsResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/budget-definitions/`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [201, 400, 403, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 201 | 400 | 403 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 201 | 400 | 403 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdBudgetDefinitions: SpendeskApi['postV2ApiCompanyIdBudgetDefinitions'] =
  async (
    request: Types.PostV2ApiCompanyIdBudgetDefinitionsRequest,
  ): Promise<Types.PostV2ApiCompanyIdBudgetDefinitionsResponses> => {
    return await _postV2ApiCompanyIdBudgetDefinitions(baseUrl, request);
  };
const _deleteV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId = async (
  url: string,
  request: Types.DeleteV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdRequest,
): Promise<Types.DeleteV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/budget-definitions/${request.path['budgetDefinitionId']}`,
    {
      method: 'DELETE',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  if (response.status === 204) {
    return {
      statusCode: response.status,
      headers: headersToJSON(response.headers),
      body: undefined,
    };
  }
  const jsonResponses = [403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 204 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const deleteV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId: SpendeskApi['deleteV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId'] =
  async (
    request: Types.DeleteV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdRequest,
  ): Promise<Types.DeleteV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdResponses> => {
    return await _deleteV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId = async (
  url: string,
  request: Types.GetV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdRequest,
): Promise<Types.GetV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/budget-definitions/${request.path['budgetDefinitionId']}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId: SpendeskApi['getV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId'] =
  async (
    request: Types.GetV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdRequest,
  ): Promise<Types.GetV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdResponses> => {
    return await _getV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId(
      baseUrl,
      request,
    );
  };
const _putV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId = async (
  url: string,
  request: Types.PutV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdRequest,
): Promise<Types.PutV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/budget-definitions/${request.path['budgetDefinitionId']}`,
    {
      method: 'PUT',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const putV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId: SpendeskApi['putV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId'] =
  async (
    request: Types.PutV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdRequest,
  ): Promise<Types.PutV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdResponses> => {
    return await _putV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdBreakdowns = async (
  url: string,
  request: Types.GetV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdBreakdownsRequest,
): Promise<Types.GetV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdBreakdownsResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdBreakdownsRequest['query']
  >)[] = ['viewStart', 'viewEnd'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/budget-definitions/${request.path['budgetDefinitionId']}/breakdowns?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdBreakdowns: SpendeskApi['getV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdBreakdowns'] =
  async (
    request: Types.GetV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdBreakdownsRequest,
  ): Promise<Types.GetV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdBreakdownsResponses> => {
    return await _getV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdBreakdowns(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdSpendings = async (
  url: string,
  request: Types.GetV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdSpendingsRequest,
): Promise<Types.GetV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdSpendingsResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdSpendingsRequest['query']
  >)[] = [
    'pageNumber',
    'pageSize',
    'costCenterId',
    'expenseCategoryId',
    'supplierId',
    'viewStart',
    'viewEnd',
    'breakdownPart',
    'spendingType',
  ];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/budget-definitions/${request.path['budgetDefinitionId']}/spendings?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdSpendings: SpendeskApi['getV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdSpendings'] =
  async (
    request: Types.GetV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdSpendingsRequest,
  ): Promise<Types.GetV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdSpendingsResponses> => {
    return await _getV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdSpendings(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdCardsFailedTransactions = async (
  url: string,
  request: Types.GetV2ApiCompanyIdCardsFailedTransactionsRequest,
): Promise<Types.GetV2ApiCompanyIdCardsFailedTransactionsResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdCardsFailedTransactionsRequest['query']
  >)[] = ['userId', 'startDate', 'endDate'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/cards/failed-transactions?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdCardsFailedTransactions: SpendeskApi['getV2ApiCompanyIdCardsFailedTransactions'] =
  async (
    request: Types.GetV2ApiCompanyIdCardsFailedTransactionsRequest,
  ): Promise<Types.GetV2ApiCompanyIdCardsFailedTransactionsResponses> => {
    return await _getV2ApiCompanyIdCardsFailedTransactions(baseUrl, request);
  };
const _postV2ApiCompanyIdCardsIncreaseLimitsRequest = async (
  url: string,
  request: Types.PostV2ApiCompanyIdCardsIncreaseLimitsRequestRequest,
): Promise<Types.PostV2ApiCompanyIdCardsIncreaseLimitsRequestResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/cards/increase-limits/request`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdCardsIncreaseLimitsRequest: SpendeskApi['postV2ApiCompanyIdCardsIncreaseLimitsRequest'] =
  async (
    request: Types.PostV2ApiCompanyIdCardsIncreaseLimitsRequestRequest,
  ): Promise<Types.PostV2ApiCompanyIdCardsIncreaseLimitsRequestResponses> => {
    return await _postV2ApiCompanyIdCardsIncreaseLimitsRequest(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdCardsIncreaseLimitsStatus = async (
  url: string,
  request: Types.GetV2ApiCompanyIdCardsIncreaseLimitsStatusRequest,
): Promise<Types.GetV2ApiCompanyIdCardsIncreaseLimitsStatusResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/cards/increase-limits/status`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdCardsIncreaseLimitsStatus: SpendeskApi['getV2ApiCompanyIdCardsIncreaseLimitsStatus'] =
  async (
    request: Types.GetV2ApiCompanyIdCardsIncreaseLimitsStatusRequest,
  ): Promise<Types.GetV2ApiCompanyIdCardsIncreaseLimitsStatusResponses> => {
    return await _getV2ApiCompanyIdCardsIncreaseLimitsStatus(baseUrl, request);
  };
const _postV2ApiCompanyIdCardsIncreaseLimitsProcedureId = async (
  url: string,
  request: Types.PostV2ApiCompanyIdCardsIncreaseLimitsProcedureIdRequest,
): Promise<Types.PostV2ApiCompanyIdCardsIncreaseLimitsProcedureIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/cards/increase-limits/${request.path['procedureId']}`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdCardsIncreaseLimitsProcedureId: SpendeskApi['postV2ApiCompanyIdCardsIncreaseLimitsProcedureId'] =
  async (
    request: Types.PostV2ApiCompanyIdCardsIncreaseLimitsProcedureIdRequest,
  ): Promise<Types.PostV2ApiCompanyIdCardsIncreaseLimitsProcedureIdResponses> => {
    return await _postV2ApiCompanyIdCardsIncreaseLimitsProcedureId(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdCardsInvoicesInvoiceRequestIdCardPaymentEligibility =
  async (
    url: string,
    request: Types.GetV2ApiCompanyIdCardsInvoicesInvoiceRequestIdCardPaymentEligibilityRequest,
  ): Promise<Types.GetV2ApiCompanyIdCardsInvoicesInvoiceRequestIdCardPaymentEligibilityResponses> => {
    const queryParameters: (keyof NonNullable<
      Types.GetV2ApiCompanyIdCardsInvoicesInvoiceRequestIdCardPaymentEligibilityRequest['query']
    >)[] = ['amount_declared', 'currency_declared'];
    const searchParams = new URLSearchParams();
    if (request.query) {
      queryParameters.forEach((qp) => {
        const queryValue = request.query?.[qp];
        if (queryValue) {
          if (Array.isArray(queryValue)) {
            queryValue.forEach((p) => searchParams.append(qp, p));
          } else {
            searchParams.append(qp, queryValue.toString());
          }
        }
        delete request.query?.[qp];
      });
    }

    const headers: HeadersInit = {
      ...defaultHeaders,
    };

    const response = await fetch(
      `${url}/v2/api/${request.path['companyId']}/cards/invoices/${request.path['invoiceRequestId']}/card-payment-eligibility?${searchParams.toString()}`,
      {
        credentials: 'include',
        headers,
        ...defaultFetchParams,
      },
    );

    const jsonResponses = [200, 400, 401, 404, 500];
    if (jsonResponses.includes(response.status)) {
      return {
        statusCode: response.status as 200 | 400 | 401 | 404 | 500,
        headers: headersToJSON(response.headers),
        body: await response.json(),
      };
    }
    const responseType = response.headers
      .get('content-type')
      ?.startsWith('application/json')
      ? 'json'
      : 'text';
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response[responseType](),
    };
  };

export const getV2ApiCompanyIdCardsInvoicesInvoiceRequestIdCardPaymentEligibility: SpendeskApi['getV2ApiCompanyIdCardsInvoicesInvoiceRequestIdCardPaymentEligibility'] =
  async (
    request: Types.GetV2ApiCompanyIdCardsInvoicesInvoiceRequestIdCardPaymentEligibilityRequest,
  ): Promise<Types.GetV2ApiCompanyIdCardsInvoicesInvoiceRequestIdCardPaymentEligibilityResponses> => {
    return await _getV2ApiCompanyIdCardsInvoicesInvoiceRequestIdCardPaymentEligibility(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdCardsInvoicesPayableIdInvoiceDetails = async (
  url: string,
  request: Types.GetV2ApiCompanyIdCardsInvoicesPayableIdInvoiceDetailsRequest,
): Promise<Types.GetV2ApiCompanyIdCardsInvoicesPayableIdInvoiceDetailsResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/cards/invoices/${request.path['payableId']}/invoice-details`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdCardsInvoicesPayableIdInvoiceDetails: SpendeskApi['getV2ApiCompanyIdCardsInvoicesPayableIdInvoiceDetails'] =
  async (
    request: Types.GetV2ApiCompanyIdCardsInvoicesPayableIdInvoiceDetailsRequest,
  ): Promise<Types.GetV2ApiCompanyIdCardsInvoicesPayableIdInvoiceDetailsResponses> => {
    return await _getV2ApiCompanyIdCardsInvoicesPayableIdInvoiceDetails(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdCardsPanShow = async (
  url: string,
  request: Types.PostV2ApiCompanyIdCardsPanShowRequest,
): Promise<Types.PostV2ApiCompanyIdCardsPanShowResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/cards/pan/show`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdCardsPanShow: SpendeskApi['postV2ApiCompanyIdCardsPanShow'] =
  async (
    request: Types.PostV2ApiCompanyIdCardsPanShowRequest,
  ): Promise<Types.PostV2ApiCompanyIdCardsPanShowResponses> => {
    return await _postV2ApiCompanyIdCardsPanShow(baseUrl, request);
  };
const _postV2ApiCompanyIdCardsPinShow = async (
  url: string,
  request: Types.PostV2ApiCompanyIdCardsPinShowRequest,
): Promise<Types.PostV2ApiCompanyIdCardsPinShowResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/cards/pin/show`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdCardsPinShow: SpendeskApi['postV2ApiCompanyIdCardsPinShow'] =
  async (
    request: Types.PostV2ApiCompanyIdCardsPinShowRequest,
  ): Promise<Types.PostV2ApiCompanyIdCardsPinShowResponses> => {
    return await _postV2ApiCompanyIdCardsPinShow(baseUrl, request);
  };
const _postV2ApiCompanyIdCardsPinProcedureId = async (
  url: string,
  request: Types.PostV2ApiCompanyIdCardsPinProcedureIdRequest,
): Promise<Types.PostV2ApiCompanyIdCardsPinProcedureIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/cards/pin/${request.path['procedureId']}`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdCardsPinProcedureId: SpendeskApi['postV2ApiCompanyIdCardsPinProcedureId'] =
  async (
    request: Types.PostV2ApiCompanyIdCardsPinProcedureIdRequest,
  ): Promise<Types.PostV2ApiCompanyIdCardsPinProcedureIdResponses> => {
    return await _postV2ApiCompanyIdCardsPinProcedureId(baseUrl, request);
  };
const _getV2ApiCompanyIdCardsSinglePurchase = async (
  url: string,
  request: Types.GetV2ApiCompanyIdCardsSinglePurchaseRequest,
): Promise<Types.GetV2ApiCompanyIdCardsSinglePurchaseResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdCardsSinglePurchaseRequest['query']
  >)[] = ['userId'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/cards/single-purchase?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdCardsSinglePurchase: SpendeskApi['getV2ApiCompanyIdCardsSinglePurchase'] =
  async (
    request: Types.GetV2ApiCompanyIdCardsSinglePurchaseRequest,
  ): Promise<Types.GetV2ApiCompanyIdCardsSinglePurchaseResponses> => {
    return await _getV2ApiCompanyIdCardsSinglePurchase(baseUrl, request);
  };
const _getV2ApiCompanyIdCardsSinglePurchaseRequestId = async (
  url: string,
  request: Types.GetV2ApiCompanyIdCardsSinglePurchaseRequestIdRequest,
): Promise<Types.GetV2ApiCompanyIdCardsSinglePurchaseRequestIdResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/cards/single-purchase/${request.path['requestId']}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdCardsSinglePurchaseRequestId: SpendeskApi['getV2ApiCompanyIdCardsSinglePurchaseRequestId'] =
  async (
    request: Types.GetV2ApiCompanyIdCardsSinglePurchaseRequestIdRequest,
  ): Promise<Types.GetV2ApiCompanyIdCardsSinglePurchaseRequestIdResponses> => {
    return await _getV2ApiCompanyIdCardsSinglePurchaseRequestId(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdCardsTransactionsTransactionId = async (
  url: string,
  request: Types.GetV2ApiCompanyIdCardsTransactionsTransactionIdRequest,
): Promise<Types.GetV2ApiCompanyIdCardsTransactionsTransactionIdResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/cards/transactions/${request.path['transactionId']}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdCardsTransactionsTransactionId: SpendeskApi['getV2ApiCompanyIdCardsTransactionsTransactionId'] =
  async (
    request: Types.GetV2ApiCompanyIdCardsTransactionsTransactionIdRequest,
  ): Promise<Types.GetV2ApiCompanyIdCardsTransactionsTransactionIdResponses> => {
    return await _getV2ApiCompanyIdCardsTransactionsTransactionId(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdCardsCardIdAggregatedActivity = async (
  url: string,
  request: Types.GetV2ApiCompanyIdCardsCardIdAggregatedActivityRequest,
): Promise<Types.GetV2ApiCompanyIdCardsCardIdAggregatedActivityResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdCardsCardIdAggregatedActivityRequest['query']
  >)[] = ['pageNumber', 'pageSize'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/cards/${request.path['cardId']}/aggregated-activity?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdCardsCardIdAggregatedActivity: SpendeskApi['getV2ApiCompanyIdCardsCardIdAggregatedActivity'] =
  async (
    request: Types.GetV2ApiCompanyIdCardsCardIdAggregatedActivityRequest,
  ): Promise<Types.GetV2ApiCompanyIdCardsCardIdAggregatedActivityResponses> => {
    return await _getV2ApiCompanyIdCardsCardIdAggregatedActivity(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdCardsCardIdPanProcedureId = async (
  url: string,
  request: Types.PostV2ApiCompanyIdCardsCardIdPanProcedureIdRequest,
): Promise<Types.PostV2ApiCompanyIdCardsCardIdPanProcedureIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/cards/${request.path['cardId']}/pan/${request.path['procedureId']}`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdCardsCardIdPanProcedureId: SpendeskApi['postV2ApiCompanyIdCardsCardIdPanProcedureId'] =
  async (
    request: Types.PostV2ApiCompanyIdCardsCardIdPanProcedureIdRequest,
  ): Promise<Types.PostV2ApiCompanyIdCardsCardIdPanProcedureIdResponses> => {
    return await _postV2ApiCompanyIdCardsCardIdPanProcedureId(baseUrl, request);
  };
const _getV2ApiCompanyIdCardsCardProductRegulatoryLimits = async (
  url: string,
  request: Types.GetV2ApiCompanyIdCardsCardProductRegulatoryLimitsRequest,
): Promise<Types.GetV2ApiCompanyIdCardsCardProductRegulatoryLimitsResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/cards/${request.path['cardProduct']}/regulatory-limits`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdCardsCardProductRegulatoryLimits: SpendeskApi['getV2ApiCompanyIdCardsCardProductRegulatoryLimits'] =
  async (
    request: Types.GetV2ApiCompanyIdCardsCardProductRegulatoryLimitsRequest,
  ): Promise<Types.GetV2ApiCompanyIdCardsCardProductRegulatoryLimitsResponses> => {
    return await _getV2ApiCompanyIdCardsCardProductRegulatoryLimits(
      baseUrl,
      request,
    );
  };
const _deleteV2ApiCompanyIdCustomFieldsCustomFieldIdValues = async (
  url: string,
  request: Types.DeleteV2ApiCompanyIdCustomFieldsCustomFieldIdValuesRequest,
): Promise<Types.DeleteV2ApiCompanyIdCustomFieldsCustomFieldIdValuesResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/custom-fields/${request.path['customFieldId']}/values`,
    {
      method: 'DELETE',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  if (response.status === 204) {
    return {
      statusCode: response.status,
      headers: headersToJSON(response.headers),
      body: undefined,
    };
  }
  const jsonResponses = [204, 400, 401, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 204 | 400 | 401 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 204 | 400 | 401 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const deleteV2ApiCompanyIdCustomFieldsCustomFieldIdValues: SpendeskApi['deleteV2ApiCompanyIdCustomFieldsCustomFieldIdValues'] =
  async (
    request: Types.DeleteV2ApiCompanyIdCustomFieldsCustomFieldIdValuesRequest,
  ): Promise<Types.DeleteV2ApiCompanyIdCustomFieldsCustomFieldIdValuesResponses> => {
    return await _deleteV2ApiCompanyIdCustomFieldsCustomFieldIdValues(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdInternationalTransfersBusinessProfiles = async (
  url: string,
  request: Types.PostV2ApiCompanyIdInternationalTransfersBusinessProfilesRequest,
): Promise<Types.PostV2ApiCompanyIdInternationalTransfersBusinessProfilesResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/international-transfers/business-profiles`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500, 502];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdInternationalTransfersBusinessProfiles: SpendeskApi['postV2ApiCompanyIdInternationalTransfersBusinessProfiles'] =
  async (
    request: Types.PostV2ApiCompanyIdInternationalTransfersBusinessProfilesRequest,
  ): Promise<Types.PostV2ApiCompanyIdInternationalTransfersBusinessProfilesResponses> => {
    return await _postV2ApiCompanyIdInternationalTransfersBusinessProfiles(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdInternationalTransfersBusinessRepresentatives = async (
  url: string,
  request: Types.GetV2ApiCompanyIdInternationalTransfersBusinessRepresentativesRequest,
): Promise<Types.GetV2ApiCompanyIdInternationalTransfersBusinessRepresentativesResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdInternationalTransfersBusinessRepresentativesRequest['query']
  >)[] = ['firstName', 'lastName'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/international-transfers/business-representatives?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500, 502];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdInternationalTransfersBusinessRepresentatives: SpendeskApi['getV2ApiCompanyIdInternationalTransfersBusinessRepresentatives'] =
  async (
    request: Types.GetV2ApiCompanyIdInternationalTransfersBusinessRepresentativesRequest,
  ): Promise<Types.GetV2ApiCompanyIdInternationalTransfersBusinessRepresentativesResponses> => {
    return await _getV2ApiCompanyIdInternationalTransfersBusinessRepresentatives(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdInternationalTransfersDeliveryEstimateTimeTransferId =
  async (
    url: string,
    request: Types.GetV2ApiCompanyIdInternationalTransfersDeliveryEstimateTimeTransferIdRequest,
  ): Promise<Types.GetV2ApiCompanyIdInternationalTransfersDeliveryEstimateTimeTransferIdResponses> => {
    const headers: HeadersInit = {
      ...defaultHeaders,
    };

    const response = await fetch(
      `${url}/v2/api/${request.path['companyId']}/international-transfers/delivery-estimate-time/${request.path['transferId']}`,
      {
        credentials: 'include',
        headers,
        ...defaultFetchParams,
      },
    );

    const jsonResponses = [200, 400, 401, 404, 500, 502];
    if (jsonResponses.includes(response.status)) {
      return {
        statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
        headers: headersToJSON(response.headers),
        body: await response.json(),
      };
    }
    const responseType = response.headers
      .get('content-type')
      ?.startsWith('application/json')
      ? 'json'
      : 'text';
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
      headers: headersToJSON(response.headers),
      body: await response[responseType](),
    };
  };

export const getV2ApiCompanyIdInternationalTransfersDeliveryEstimateTimeTransferId: SpendeskApi['getV2ApiCompanyIdInternationalTransfersDeliveryEstimateTimeTransferId'] =
  async (
    request: Types.GetV2ApiCompanyIdInternationalTransfersDeliveryEstimateTimeTransferIdRequest,
  ): Promise<Types.GetV2ApiCompanyIdInternationalTransfersDeliveryEstimateTimeTransferIdResponses> => {
    return await _getV2ApiCompanyIdInternationalTransfersDeliveryEstimateTimeTransferId(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdInternationalTransfersKycReviews = async (
  url: string,
  request: Types.PostV2ApiCompanyIdInternationalTransfersKycReviewsRequest,
): Promise<Types.PostV2ApiCompanyIdInternationalTransfersKycReviewsResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/international-transfers/kyc-reviews`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500, 502];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdInternationalTransfersKycReviews: SpendeskApi['postV2ApiCompanyIdInternationalTransfersKycReviews'] =
  async (
    request: Types.PostV2ApiCompanyIdInternationalTransfersKycReviewsRequest,
  ): Promise<Types.PostV2ApiCompanyIdInternationalTransfersKycReviewsResponses> => {
    return await _postV2ApiCompanyIdInternationalTransfersKycReviews(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdInternationalTransfersKycStatus = async (
  url: string,
  request: Types.GetV2ApiCompanyIdInternationalTransfersKycStatusRequest,
): Promise<Types.GetV2ApiCompanyIdInternationalTransfersKycStatusResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/international-transfers/kyc-status`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500, 502];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdInternationalTransfersKycStatus: SpendeskApi['getV2ApiCompanyIdInternationalTransfersKycStatus'] =
  async (
    request: Types.GetV2ApiCompanyIdInternationalTransfersKycStatusRequest,
  ): Promise<Types.GetV2ApiCompanyIdInternationalTransfersKycStatusResponses> => {
    return await _getV2ApiCompanyIdInternationalTransfersKycStatus(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdInternationalTransfersQuotes = async (
  url: string,
  request: Types.PostV2ApiCompanyIdInternationalTransfersQuotesRequest,
): Promise<Types.PostV2ApiCompanyIdInternationalTransfersQuotesResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/international-transfers/quotes`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500, 502];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdInternationalTransfersQuotes: SpendeskApi['postV2ApiCompanyIdInternationalTransfersQuotes'] =
  async (
    request: Types.PostV2ApiCompanyIdInternationalTransfersQuotesRequest,
  ): Promise<Types.PostV2ApiCompanyIdInternationalTransfersQuotesResponses> => {
    return await _postV2ApiCompanyIdInternationalTransfersQuotes(
      baseUrl,
      request,
    );
  };
const _patchV2ApiCompanyIdInternationalTransfersQuotesId = async (
  url: string,
  request: Types.PatchV2ApiCompanyIdInternationalTransfersQuotesIdRequest,
): Promise<Types.PatchV2ApiCompanyIdInternationalTransfersQuotesIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/international-transfers/quotes/${request.path['id']}`,
    {
      method: 'PATCH',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500, 502];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const patchV2ApiCompanyIdInternationalTransfersQuotesId: SpendeskApi['patchV2ApiCompanyIdInternationalTransfersQuotesId'] =
  async (
    request: Types.PatchV2ApiCompanyIdInternationalTransfersQuotesIdRequest,
  ): Promise<Types.PatchV2ApiCompanyIdInternationalTransfersQuotesIdResponses> => {
    return await _patchV2ApiCompanyIdInternationalTransfersQuotesId(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdInternationalTransfersRecipientRequirements = async (
  url: string,
  request: Types.GetV2ApiCompanyIdInternationalTransfersRecipientRequirementsRequest,
): Promise<Types.GetV2ApiCompanyIdInternationalTransfersRecipientRequirementsResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdInternationalTransfersRecipientRequirementsRequest['query']
  >)[] = ['quoteId', 'acceptLanguage'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/international-transfers/recipient-requirements?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500, 502];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdInternationalTransfersRecipientRequirements: SpendeskApi['getV2ApiCompanyIdInternationalTransfersRecipientRequirements'] =
  async (
    request: Types.GetV2ApiCompanyIdInternationalTransfersRecipientRequirementsRequest,
  ): Promise<Types.GetV2ApiCompanyIdInternationalTransfersRecipientRequirementsResponses> => {
    return await _getV2ApiCompanyIdInternationalTransfersRecipientRequirements(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdInternationalTransfersRecipientRequirements = async (
  url: string,
  request: Types.PostV2ApiCompanyIdInternationalTransfersRecipientRequirementsRequest,
): Promise<Types.PostV2ApiCompanyIdInternationalTransfersRecipientRequirementsResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/international-transfers/recipient-requirements`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500, 502];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdInternationalTransfersRecipientRequirements: SpendeskApi['postV2ApiCompanyIdInternationalTransfersRecipientRequirements'] =
  async (
    request: Types.PostV2ApiCompanyIdInternationalTransfersRecipientRequirementsRequest,
  ): Promise<Types.PostV2ApiCompanyIdInternationalTransfersRecipientRequirementsResponses> => {
    return await _postV2ApiCompanyIdInternationalTransfersRecipientRequirements(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdInternationalTransfersRecipients = async (
  url: string,
  request: Types.GetV2ApiCompanyIdInternationalTransfersRecipientsRequest,
): Promise<Types.GetV2ApiCompanyIdInternationalTransfersRecipientsResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdInternationalTransfersRecipientsRequest['query']
  >)[] = ['clientRef', 'offset', 'count'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/international-transfers/recipients?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500, 502];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdInternationalTransfersRecipients: SpendeskApi['getV2ApiCompanyIdInternationalTransfersRecipients'] =
  async (
    request: Types.GetV2ApiCompanyIdInternationalTransfersRecipientsRequest,
  ): Promise<Types.GetV2ApiCompanyIdInternationalTransfersRecipientsResponses> => {
    return await _getV2ApiCompanyIdInternationalTransfersRecipients(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdInternationalTransfersRecipients = async (
  url: string,
  request: Types.PostV2ApiCompanyIdInternationalTransfersRecipientsRequest,
): Promise<Types.PostV2ApiCompanyIdInternationalTransfersRecipientsResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/international-transfers/recipients`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500, 502];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdInternationalTransfersRecipients: SpendeskApi['postV2ApiCompanyIdInternationalTransfersRecipients'] =
  async (
    request: Types.PostV2ApiCompanyIdInternationalTransfersRecipientsRequest,
  ): Promise<Types.PostV2ApiCompanyIdInternationalTransfersRecipientsResponses> => {
    return await _postV2ApiCompanyIdInternationalTransfersRecipients(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdInternationalTransfersRecipientsId = async (
  url: string,
  request: Types.GetV2ApiCompanyIdInternationalTransfersRecipientsIdRequest,
): Promise<Types.GetV2ApiCompanyIdInternationalTransfersRecipientsIdResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdInternationalTransfersRecipientsIdRequest['query']
  >)[] = ['validate'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/international-transfers/recipients/${request.path['id']}?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500, 502];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdInternationalTransfersRecipientsId: SpendeskApi['getV2ApiCompanyIdInternationalTransfersRecipientsId'] =
  async (
    request: Types.GetV2ApiCompanyIdInternationalTransfersRecipientsIdRequest,
  ): Promise<Types.GetV2ApiCompanyIdInternationalTransfersRecipientsIdResponses> => {
    return await _getV2ApiCompanyIdInternationalTransfersRecipientsId(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdInternationalTransfersTransferRequirements = async (
  url: string,
  request: Types.PostV2ApiCompanyIdInternationalTransfersTransferRequirementsRequest,
): Promise<Types.PostV2ApiCompanyIdInternationalTransfersTransferRequirementsResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/international-transfers/transfer-requirements`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500, 502];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdInternationalTransfersTransferRequirements: SpendeskApi['postV2ApiCompanyIdInternationalTransfersTransferRequirements'] =
  async (
    request: Types.PostV2ApiCompanyIdInternationalTransfersTransferRequirementsRequest,
  ): Promise<Types.PostV2ApiCompanyIdInternationalTransfersTransferRequirementsResponses> => {
    return await _postV2ApiCompanyIdInternationalTransfersTransferRequirements(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdInternationalTransfersTransferId = async (
  url: string,
  request: Types.GetV2ApiCompanyIdInternationalTransfersTransferIdRequest,
): Promise<Types.GetV2ApiCompanyIdInternationalTransfersTransferIdResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/international-transfers/transfer/${request.path['id']}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500, 502];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdInternationalTransfersTransferId: SpendeskApi['getV2ApiCompanyIdInternationalTransfersTransferId'] =
  async (
    request: Types.GetV2ApiCompanyIdInternationalTransfersTransferIdRequest,
  ): Promise<Types.GetV2ApiCompanyIdInternationalTransfersTransferIdResponses> => {
    return await _getV2ApiCompanyIdInternationalTransfersTransferId(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdInternationalTransfersValidateRecipient = async (
  url: string,
  request: Types.PostV2ApiCompanyIdInternationalTransfersValidateRecipientRequest,
): Promise<Types.PostV2ApiCompanyIdInternationalTransfersValidateRecipientResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/international-transfers/validate-recipient`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500, 502];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdInternationalTransfersValidateRecipient: SpendeskApi['postV2ApiCompanyIdInternationalTransfersValidateRecipient'] =
  async (
    request: Types.PostV2ApiCompanyIdInternationalTransfersValidateRecipientRequest,
  ): Promise<Types.PostV2ApiCompanyIdInternationalTransfersValidateRecipientResponses> => {
    return await _postV2ApiCompanyIdInternationalTransfersValidateRecipient(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdInvoiceRequestsLineItemsMatching = async (
  url: string,
  request: Types.PostV2ApiCompanyIdInvoiceRequestsLineItemsMatchingRequest,
): Promise<Types.PostV2ApiCompanyIdInvoiceRequestsLineItemsMatchingResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/invoice-requests/line-items-matching`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdInvoiceRequestsLineItemsMatching: SpendeskApi['postV2ApiCompanyIdInvoiceRequestsLineItemsMatching'] =
  async (
    request: Types.PostV2ApiCompanyIdInvoiceRequestsLineItemsMatchingRequest,
  ): Promise<Types.PostV2ApiCompanyIdInvoiceRequestsLineItemsMatchingResponses> => {
    return await _postV2ApiCompanyIdInvoiceRequestsLineItemsMatching(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdPaymentsPaymentIdExpenseBeneficiaries = async (
  url: string,
  request: Types.GetV2ApiCompanyIdPaymentsPaymentIdExpenseBeneficiariesRequest,
): Promise<Types.GetV2ApiCompanyIdPaymentsPaymentIdExpenseBeneficiariesResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/payments/${request.path['paymentId']}/expense-beneficiaries`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdPaymentsPaymentIdExpenseBeneficiaries: SpendeskApi['getV2ApiCompanyIdPaymentsPaymentIdExpenseBeneficiaries'] =
  async (
    request: Types.GetV2ApiCompanyIdPaymentsPaymentIdExpenseBeneficiariesRequest,
  ): Promise<Types.GetV2ApiCompanyIdPaymentsPaymentIdExpenseBeneficiariesResponses> => {
    return await _getV2ApiCompanyIdPaymentsPaymentIdExpenseBeneficiaries(
      baseUrl,
      request,
    );
  };
const _putV2ApiCompanyIdPaymentsPaymentIdExpenseBeneficiaries = async (
  url: string,
  request: Types.PutV2ApiCompanyIdPaymentsPaymentIdExpenseBeneficiariesRequest,
): Promise<Types.PutV2ApiCompanyIdPaymentsPaymentIdExpenseBeneficiariesResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/payments/${request.path['paymentId']}/expense-beneficiaries`,
    {
      method: 'PUT',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  if (response.status === 204) {
    return {
      statusCode: response.status,
      headers: headersToJSON(response.headers),
      body: undefined,
    };
  }
  const jsonResponses = [400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 204 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const putV2ApiCompanyIdPaymentsPaymentIdExpenseBeneficiaries: SpendeskApi['putV2ApiCompanyIdPaymentsPaymentIdExpenseBeneficiaries'] =
  async (
    request: Types.PutV2ApiCompanyIdPaymentsPaymentIdExpenseBeneficiariesRequest,
  ): Promise<Types.PutV2ApiCompanyIdPaymentsPaymentIdExpenseBeneficiariesResponses> => {
    return await _putV2ApiCompanyIdPaymentsPaymentIdExpenseBeneficiaries(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdPurchaseOrdersExtraction = async (
  url: string,
  request: Types.PostV2ApiCompanyIdPurchaseOrdersExtractionRequest,
): Promise<Types.PostV2ApiCompanyIdPurchaseOrdersExtractionResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/purchase-orders/extraction`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdPurchaseOrdersExtraction: SpendeskApi['postV2ApiCompanyIdPurchaseOrdersExtraction'] =
  async (
    request: Types.PostV2ApiCompanyIdPurchaseOrdersExtractionRequest,
  ): Promise<Types.PostV2ApiCompanyIdPurchaseOrdersExtractionResponses> => {
    return await _postV2ApiCompanyIdPurchaseOrdersExtraction(baseUrl, request);
  };
const _getV2ApiCompanyIdPurchaseOrdersSettings = async (
  url: string,
  request: Types.GetV2ApiCompanyIdPurchaseOrdersSettingsRequest,
): Promise<Types.GetV2ApiCompanyIdPurchaseOrdersSettingsResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/purchase-orders/settings`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdPurchaseOrdersSettings: SpendeskApi['getV2ApiCompanyIdPurchaseOrdersSettings'] =
  async (
    request: Types.GetV2ApiCompanyIdPurchaseOrdersSettingsRequest,
  ): Promise<Types.GetV2ApiCompanyIdPurchaseOrdersSettingsResponses> => {
    return await _getV2ApiCompanyIdPurchaseOrdersSettings(baseUrl, request);
  };
const _putV2ApiCompanyIdPurchaseOrdersSettings = async (
  url: string,
  request: Types.PutV2ApiCompanyIdPurchaseOrdersSettingsRequest,
): Promise<Types.PutV2ApiCompanyIdPurchaseOrdersSettingsResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/purchase-orders/settings`,
    {
      method: 'PUT',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const putV2ApiCompanyIdPurchaseOrdersSettings: SpendeskApi['putV2ApiCompanyIdPurchaseOrdersSettings'] =
  async (
    request: Types.PutV2ApiCompanyIdPurchaseOrdersSettingsRequest,
  ): Promise<Types.PutV2ApiCompanyIdPurchaseOrdersSettingsResponses> => {
    return await _putV2ApiCompanyIdPurchaseOrdersSettings(baseUrl, request);
  };
const _postV2ApiCompanyIdPurchaseOrdersPurchaseOrderId = async (
  url: string,
  request: Types.PostV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdRequest,
): Promise<Types.PostV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/purchase-orders/${request.path['purchaseOrderId']}`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 422, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 422 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 422 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdPurchaseOrdersPurchaseOrderId: SpendeskApi['postV2ApiCompanyIdPurchaseOrdersPurchaseOrderId'] =
  async (
    request: Types.PostV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdRequest,
  ): Promise<Types.PostV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdResponses> => {
    return await _postV2ApiCompanyIdPurchaseOrdersPurchaseOrderId(
      baseUrl,
      request,
    );
  };
const _putV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdDocument = async (
  url: string,
  request: Types.PutV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdDocumentRequest,
): Promise<Types.PutV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdDocumentResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/purchase-orders/${request.path['purchaseOrderId']}/document`,
    {
      method: 'PUT',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const putV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdDocument: SpendeskApi['putV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdDocument'] =
  async (
    request: Types.PutV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdDocumentRequest,
  ): Promise<Types.PutV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdDocumentResponses> => {
    return await _putV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdDocument(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdQuote = async (
  url: string,
  request: Types.PostV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdQuoteRequest,
): Promise<Types.PostV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdQuoteResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/purchase-orders/${request.path['purchaseOrderId']}/quote`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdQuote: SpendeskApi['postV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdQuote'] =
  async (
    request: Types.PostV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdQuoteRequest,
  ): Promise<Types.PostV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdQuoteResponses> => {
    return await _postV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdQuote(
      baseUrl,
      request,
    );
  };
const _deleteV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdQuotesQuoteId = async (
  url: string,
  request: Types.DeleteV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdQuotesQuoteIdRequest,
): Promise<Types.DeleteV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdQuotesQuoteIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/purchase-orders/${request.path['purchaseOrderId']}/quotes/${request.path['quoteId']}`,
    {
      method: 'DELETE',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const deleteV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdQuotesQuoteId: SpendeskApi['deleteV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdQuotesQuoteId'] =
  async (
    request: Types.DeleteV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdQuotesQuoteIdRequest,
  ): Promise<Types.DeleteV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdQuotesQuoteIdResponses> => {
    return await _deleteV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdQuotesQuoteId(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdSendEmailToSupplier =
  async (
    url: string,
    request: Types.PostV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdSendEmailToSupplierRequest,
  ): Promise<Types.PostV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdSendEmailToSupplierResponses> => {
    const body = 'body' in request ? request.body : undefined;
    const isFormData = body instanceof FormData;
    const headers: HeadersInit = {
      ...defaultHeaders,
      ...(isFormData || body === undefined ? {} : defaultJsonType),
    };

    const response = await fetch(
      `${url}/v2/api/${request.path['companyId']}/purchase-orders/${request.path['purchaseOrderId']}/send-email-to-supplier`,
      {
        method: 'POST',
        body: isFormData ? body : JSON.stringify(body),
        credentials: 'include',
        headers,
        ...defaultFetchParams,
      },
    );

    const jsonResponses = [200, 400, 401, 404, 500];
    if (jsonResponses.includes(response.status)) {
      return {
        statusCode: response.status as 200 | 400 | 401 | 404 | 500,
        headers: headersToJSON(response.headers),
        body: await response.json(),
      };
    }
    const responseType = response.headers
      .get('content-type')
      ?.startsWith('application/json')
      ? 'json'
      : 'text';
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response[responseType](),
    };
  };

export const postV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdSendEmailToSupplier: SpendeskApi['postV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdSendEmailToSupplier'] =
  async (
    request: Types.PostV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdSendEmailToSupplierRequest,
  ): Promise<Types.PostV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdSendEmailToSupplierResponses> => {
    return await _postV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdSendEmailToSupplier(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdThreeWayMatchLinesSummary =
  async (
    url: string,
    request: Types.GetV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdThreeWayMatchLinesSummaryRequest,
  ): Promise<Types.GetV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdThreeWayMatchLinesSummaryResponses> => {
    const headers: HeadersInit = {
      ...defaultHeaders,
    };

    const response = await fetch(
      `${url}/v2/api/${request.path['companyId']}/purchase-orders/${request.path['purchaseOrderId']}/three-way-match/lines-summary`,
      {
        credentials: 'include',
        headers,
        ...defaultFetchParams,
      },
    );

    const jsonResponses = [200, 400, 401, 404, 500];
    if (jsonResponses.includes(response.status)) {
      return {
        statusCode: response.status as 200 | 400 | 401 | 404 | 500,
        headers: headersToJSON(response.headers),
        body: await response.json(),
      };
    }
    const responseType = response.headers
      .get('content-type')
      ?.startsWith('application/json')
      ? 'json'
      : 'text';
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response[responseType](),
    };
  };

export const getV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdThreeWayMatchLinesSummary: SpendeskApi['getV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdThreeWayMatchLinesSummary'] =
  async (
    request: Types.GetV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdThreeWayMatchLinesSummaryRequest,
  ): Promise<Types.GetV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdThreeWayMatchLinesSummaryResponses> => {
    return await _getV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdThreeWayMatchLinesSummary(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotes = async (
  url: string,
  request: Types.GetV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesRequest,
): Promise<Types.GetV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/purchase-orders/${request.path['requestId']}/delivery-notes`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotes: SpendeskApi['getV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotes'] =
  async (
    request: Types.GetV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesRequest,
  ): Promise<Types.GetV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesResponses> => {
    return await _getV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotes(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotes = async (
  url: string,
  request: Types.PostV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesRequest,
): Promise<Types.PostV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/purchase-orders/${request.path['requestId']}/delivery-notes`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotes: SpendeskApi['postV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotes'] =
  async (
    request: Types.PostV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesRequest,
  ): Promise<Types.PostV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesResponses> => {
    return await _postV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotes(
      baseUrl,
      request,
    );
  };
const _putV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesExpected = async (
  url: string,
  request: Types.PutV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesExpectedRequest,
): Promise<Types.PutV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesExpectedResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/purchase-orders/${request.path['requestId']}/delivery-notes/expected`,
    {
      method: 'PUT',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const putV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesExpected: SpendeskApi['putV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesExpected'] =
  async (
    request: Types.PutV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesExpectedRequest,
  ): Promise<Types.PutV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesExpectedResponses> => {
    return await _putV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesExpected(
      baseUrl,
      request,
    );
  };
const _deleteV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteId =
  async (
    url: string,
    request: Types.DeleteV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteIdRequest,
  ): Promise<Types.DeleteV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteIdResponses> => {
    const body = 'body' in request ? request.body : undefined;
    const isFormData = body instanceof FormData;
    const headers: HeadersInit = {
      ...defaultHeaders,
      ...(isFormData || body === undefined ? {} : defaultJsonType),
    };

    const response = await fetch(
      `${url}/v2/api/${request.path['companyId']}/purchase-orders/${request.path['requestId']}/delivery-notes/${request.path['deliveryNoteId']}`,
      {
        method: 'DELETE',
        body: isFormData ? body : JSON.stringify(body),
        credentials: 'include',
        headers,
        ...defaultFetchParams,
      },
    );

    const jsonResponses = [200, 400, 401, 404, 500];
    if (jsonResponses.includes(response.status)) {
      return {
        statusCode: response.status as 200 | 400 | 401 | 404 | 500,
        headers: headersToJSON(response.headers),
        body: await response.json(),
      };
    }
    const responseType = response.headers
      .get('content-type')
      ?.startsWith('application/json')
      ? 'json'
      : 'text';
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response[responseType](),
    };
  };

export const deleteV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteId: SpendeskApi['deleteV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteId'] =
  async (
    request: Types.DeleteV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteIdRequest,
  ): Promise<Types.DeleteV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteIdResponses> => {
    return await _deleteV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteId(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteId =
  async (
    url: string,
    request: Types.GetV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteIdRequest,
  ): Promise<Types.GetV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteIdResponses> => {
    const headers: HeadersInit = {
      ...defaultHeaders,
    };

    const response = await fetch(
      `${url}/v2/api/${request.path['companyId']}/purchase-orders/${request.path['requestId']}/delivery-notes/${request.path['deliveryNoteId']}`,
      {
        credentials: 'include',
        headers,
        ...defaultFetchParams,
      },
    );

    const jsonResponses = [200, 400, 401, 404, 500];
    if (jsonResponses.includes(response.status)) {
      return {
        statusCode: response.status as 200 | 400 | 401 | 404 | 500,
        headers: headersToJSON(response.headers),
        body: await response.json(),
      };
    }
    const responseType = response.headers
      .get('content-type')
      ?.startsWith('application/json')
      ? 'json'
      : 'text';
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response[responseType](),
    };
  };

export const getV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteId: SpendeskApi['getV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteId'] =
  async (
    request: Types.GetV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteIdRequest,
  ): Promise<Types.GetV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteIdResponses> => {
    return await _getV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteId(
      baseUrl,
      request,
    );
  };
const _putV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteId =
  async (
    url: string,
    request: Types.PutV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteIdRequest,
  ): Promise<Types.PutV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteIdResponses> => {
    const body = 'body' in request ? request.body : undefined;
    const isFormData = body instanceof FormData;
    const headers: HeadersInit = {
      ...defaultHeaders,
      ...(isFormData || body === undefined ? {} : defaultJsonType),
    };

    const response = await fetch(
      `${url}/v2/api/${request.path['companyId']}/purchase-orders/${request.path['requestId']}/delivery-notes/${request.path['deliveryNoteId']}`,
      {
        method: 'PUT',
        body: isFormData ? body : JSON.stringify(body),
        credentials: 'include',
        headers,
        ...defaultFetchParams,
      },
    );

    const jsonResponses = [200, 400, 401, 404, 500];
    if (jsonResponses.includes(response.status)) {
      return {
        statusCode: response.status as 200 | 400 | 401 | 404 | 500,
        headers: headersToJSON(response.headers),
        body: await response.json(),
      };
    }
    const responseType = response.headers
      .get('content-type')
      ?.startsWith('application/json')
      ? 'json'
      : 'text';
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response[responseType](),
    };
  };

export const putV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteId: SpendeskApi['putV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteId'] =
  async (
    request: Types.PutV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteIdRequest,
  ): Promise<Types.PutV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteIdResponses> => {
    return await _putV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteId(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdPurchaseOrdersRequestIdQuantityDelivered = async (
  url: string,
  request: Types.GetV2ApiCompanyIdPurchaseOrdersRequestIdQuantityDeliveredRequest,
): Promise<Types.GetV2ApiCompanyIdPurchaseOrdersRequestIdQuantityDeliveredResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/purchase-orders/${request.path['requestId']}/quantity-delivered`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdPurchaseOrdersRequestIdQuantityDelivered: SpendeskApi['getV2ApiCompanyIdPurchaseOrdersRequestIdQuantityDelivered'] =
  async (
    request: Types.GetV2ApiCompanyIdPurchaseOrdersRequestIdQuantityDeliveredRequest,
  ): Promise<Types.GetV2ApiCompanyIdPurchaseOrdersRequestIdQuantityDeliveredResponses> => {
    return await _getV2ApiCompanyIdPurchaseOrdersRequestIdQuantityDelivered(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdRequestsApprovals = async (
  url: string,
  request: Types.PostV2ApiCompanyIdRequestsApprovalsRequest,
): Promise<Types.PostV2ApiCompanyIdRequestsApprovalsResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/requests/approvals`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdRequestsApprovals: SpendeskApi['postV2ApiCompanyIdRequestsApprovals'] =
  async (
    request: Types.PostV2ApiCompanyIdRequestsApprovalsRequest,
  ): Promise<Types.PostV2ApiCompanyIdRequestsApprovalsResponses> => {
    return await _postV2ApiCompanyIdRequestsApprovals(baseUrl, request);
  };
const _postV2ApiCompanyIdRequestsDenials = async (
  url: string,
  request: Types.PostV2ApiCompanyIdRequestsDenialsRequest,
): Promise<Types.PostV2ApiCompanyIdRequestsDenialsResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/requests/denials`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdRequestsDenials: SpendeskApi['postV2ApiCompanyIdRequestsDenials'] =
  async (
    request: Types.PostV2ApiCompanyIdRequestsDenialsRequest,
  ): Promise<Types.PostV2ApiCompanyIdRequestsDenialsResponses> => {
    return await _postV2ApiCompanyIdRequestsDenials(baseUrl, request);
  };
const _getV2ApiCompanyIdRequestsDraft = async (
  url: string,
  request: Types.GetV2ApiCompanyIdRequestsDraftRequest,
): Promise<Types.GetV2ApiCompanyIdRequestsDraftResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdRequestsDraftRequest['query']
  >)[] = [
    'orderingKey',
    'orderingOrder',
    'enrichRequestReceipts',
    'enrichRequestReceiptExtractedInformations',
    'enrichTravelBudgetRequestData',
  ];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/requests/draft?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdRequestsDraft: SpendeskApi['getV2ApiCompanyIdRequestsDraft'] =
  async (
    request: Types.GetV2ApiCompanyIdRequestsDraftRequest,
  ): Promise<Types.GetV2ApiCompanyIdRequestsDraftResponses> => {
    return await _getV2ApiCompanyIdRequestsDraft(baseUrl, request);
  };
const _postV2ApiCompanyIdRequestsDraftsSubmits = async (
  url: string,
  request: Types.PostV2ApiCompanyIdRequestsDraftsSubmitsRequest,
): Promise<Types.PostV2ApiCompanyIdRequestsDraftsSubmitsResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/requests/drafts/submits`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdRequestsDraftsSubmits: SpendeskApi['postV2ApiCompanyIdRequestsDraftsSubmits'] =
  async (
    request: Types.PostV2ApiCompanyIdRequestsDraftsSubmitsRequest,
  ): Promise<Types.PostV2ApiCompanyIdRequestsDraftsSubmitsResponses> => {
    return await _postV2ApiCompanyIdRequestsDraftsSubmits(baseUrl, request);
  };
const _postV2ApiCompanyIdRequestsMileage = async (
  url: string,
  request: Types.PostV2ApiCompanyIdRequestsMileageRequest,
): Promise<Types.PostV2ApiCompanyIdRequestsMileageResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/requests/mileage`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [201, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 201 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 201 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdRequestsMileage: SpendeskApi['postV2ApiCompanyIdRequestsMileage'] =
  async (
    request: Types.PostV2ApiCompanyIdRequestsMileageRequest,
  ): Promise<Types.PostV2ApiCompanyIdRequestsMileageResponses> => {
    return await _postV2ApiCompanyIdRequestsMileage(baseUrl, request);
  };
const _postV2ApiCompanyIdRequestsMileageComputation = async (
  url: string,
  request: Types.PostV2ApiCompanyIdRequestsMileageComputationRequest,
): Promise<Types.PostV2ApiCompanyIdRequestsMileageComputationResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/requests/mileage/computation`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdRequestsMileageComputation: SpendeskApi['postV2ApiCompanyIdRequestsMileageComputation'] =
  async (
    request: Types.PostV2ApiCompanyIdRequestsMileageComputationRequest,
  ): Promise<Types.PostV2ApiCompanyIdRequestsMileageComputationResponses> => {
    return await _postV2ApiCompanyIdRequestsMileageComputation(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdRequestsToApprove = async (
  url: string,
  request: Types.GetV2ApiCompanyIdRequestsToApproveRequest,
): Promise<Types.GetV2ApiCompanyIdRequestsToApproveResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdRequestsToApproveRequest['query']
  >)[] = [
    'orderingKey',
    'orderingOrder',
    'enrichRequestReceipts',
    'enrichRequestReceiptExtractedInformations',
    'enrichRequestSpendLimitStatus',
    'enrichTravelBudgetRequestData',
  ];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/requests/to-approve?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdRequestsToApprove: SpendeskApi['getV2ApiCompanyIdRequestsToApprove'] =
  async (
    request: Types.GetV2ApiCompanyIdRequestsToApproveRequest,
  ): Promise<Types.GetV2ApiCompanyIdRequestsToApproveResponses> => {
    return await _getV2ApiCompanyIdRequestsToApprove(baseUrl, request);
  };
const _getV2ApiCompanyIdRequestsRequestId = async (
  url: string,
  request: Types.GetV2ApiCompanyIdRequestsRequestIdRequest,
): Promise<Types.GetV2ApiCompanyIdRequestsRequestIdResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdRequestsRequestIdRequest['query']
  >)[] = [
    'enrichRequestEvents',
    'enrichRequestUser',
    'includeUsers',
    'enrichRequestSupplier',
    'enrichRequestCostCenter',
    'enrichRequestCustomFieldsAssociations',
    'enrichRequestReceipts',
    'enrichRequestReceiptExtractedInformations',
    'enrichRequestUserRequestCapabilities',
    'enrichRequestDraftCompletion',
    'enrichTravelBudgetRequestData',
    'enrichRequestGroup',
    'enrichRequestApprovalAppraisals',
    'enrichRequestApprovalState',
    'enrichRequestControllerValidations',
    'includeCustomFields',
  ];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/requests/${request.path['requestId']}?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdRequestsRequestId: SpendeskApi['getV2ApiCompanyIdRequestsRequestId'] =
  async (
    request: Types.GetV2ApiCompanyIdRequestsRequestIdRequest,
  ): Promise<Types.GetV2ApiCompanyIdRequestsRequestIdResponses> => {
    return await _getV2ApiCompanyIdRequestsRequestId(baseUrl, request);
  };
const _putV2ApiCompanyIdRequestsRequestIdDraft = async (
  url: string,
  request: Types.PutV2ApiCompanyIdRequestsRequestIdDraftRequest,
): Promise<Types.PutV2ApiCompanyIdRequestsRequestIdDraftResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/requests/${request.path['requestId']}/draft`,
    {
      method: 'PUT',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const putV2ApiCompanyIdRequestsRequestIdDraft: SpendeskApi['putV2ApiCompanyIdRequestsRequestIdDraft'] =
  async (
    request: Types.PutV2ApiCompanyIdRequestsRequestIdDraftRequest,
  ): Promise<Types.PutV2ApiCompanyIdRequestsRequestIdDraftResponses> => {
    return await _putV2ApiCompanyIdRequestsRequestIdDraft(baseUrl, request);
  };
const _getV2ApiCompanyIdRequestsRequestIdExpenseBeneficiaries = async (
  url: string,
  request: Types.GetV2ApiCompanyIdRequestsRequestIdExpenseBeneficiariesRequest,
): Promise<Types.GetV2ApiCompanyIdRequestsRequestIdExpenseBeneficiariesResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/requests/${request.path['requestId']}/expense-beneficiaries`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdRequestsRequestIdExpenseBeneficiaries: SpendeskApi['getV2ApiCompanyIdRequestsRequestIdExpenseBeneficiaries'] =
  async (
    request: Types.GetV2ApiCompanyIdRequestsRequestIdExpenseBeneficiariesRequest,
  ): Promise<Types.GetV2ApiCompanyIdRequestsRequestIdExpenseBeneficiariesResponses> => {
    return await _getV2ApiCompanyIdRequestsRequestIdExpenseBeneficiaries(
      baseUrl,
      request,
    );
  };
const _putV2ApiCompanyIdRequestsRequestIdExpenseBeneficiaries = async (
  url: string,
  request: Types.PutV2ApiCompanyIdRequestsRequestIdExpenseBeneficiariesRequest,
): Promise<Types.PutV2ApiCompanyIdRequestsRequestIdExpenseBeneficiariesResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/requests/${request.path['requestId']}/expense-beneficiaries`,
    {
      method: 'PUT',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  if (response.status === 204) {
    return {
      statusCode: response.status,
      headers: headersToJSON(response.headers),
      body: undefined,
    };
  }
  const jsonResponses = [400, 401, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 400 | 401 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 204 | 400 | 401 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const putV2ApiCompanyIdRequestsRequestIdExpenseBeneficiaries: SpendeskApi['putV2ApiCompanyIdRequestsRequestIdExpenseBeneficiaries'] =
  async (
    request: Types.PutV2ApiCompanyIdRequestsRequestIdExpenseBeneficiariesRequest,
  ): Promise<Types.PutV2ApiCompanyIdRequestsRequestIdExpenseBeneficiariesResponses> => {
    return await _putV2ApiCompanyIdRequestsRequestIdExpenseBeneficiaries(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdSpendLimitStatus = async (
  url: string,
  request: Types.GetV2ApiCompanyIdSpendLimitStatusRequest,
): Promise<Types.GetV2ApiCompanyIdSpendLimitStatusResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdSpendLimitStatusRequest['query']
  >)[] = ['expenseCategoryId', 'date'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/spend-limit/status/?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 403, 404];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 403 | 404,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 403 | 404,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdSpendLimitStatus: SpendeskApi['getV2ApiCompanyIdSpendLimitStatus'] =
  async (
    request: Types.GetV2ApiCompanyIdSpendLimitStatusRequest,
  ): Promise<Types.GetV2ApiCompanyIdSpendLimitStatusResponses> => {
    return await _getV2ApiCompanyIdSpendLimitStatus(baseUrl, request);
  };
const _getV2ApiCompanyIdSpendLimitStatusByRequestRequestId = async (
  url: string,
  request: Types.GetV2ApiCompanyIdSpendLimitStatusByRequestRequestIdRequest,
): Promise<Types.GetV2ApiCompanyIdSpendLimitStatusByRequestRequestIdResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdSpendLimitStatusByRequestRequestIdRequest['query']
  >)[] = ['expenseCategoryIdOverride', 'utcDateOverride'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/spend-limit/status/by-request/${request.path['requestId']}?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 403, 404];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 403 | 404,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 403 | 404,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdSpendLimitStatusByRequestRequestId: SpendeskApi['getV2ApiCompanyIdSpendLimitStatusByRequestRequestId'] =
  async (
    request: Types.GetV2ApiCompanyIdSpendLimitStatusByRequestRequestIdRequest,
  ): Promise<Types.GetV2ApiCompanyIdSpendLimitStatusByRequestRequestIdResponses> => {
    return await _getV2ApiCompanyIdSpendLimitStatusByRequestRequestId(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdSpendLimits = async (
  url: string,
  request: Types.GetV2ApiCompanyIdSpendLimitsRequest,
): Promise<Types.GetV2ApiCompanyIdSpendLimitsResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/spend-limits/`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 403];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 403,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 403,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdSpendLimits: SpendeskApi['getV2ApiCompanyIdSpendLimits'] =
  async (
    request: Types.GetV2ApiCompanyIdSpendLimitsRequest,
  ): Promise<Types.GetV2ApiCompanyIdSpendLimitsResponses> => {
    return await _getV2ApiCompanyIdSpendLimits(baseUrl, request);
  };
const _postV2ApiCompanyIdSpendLimits = async (
  url: string,
  request: Types.PostV2ApiCompanyIdSpendLimitsRequest,
): Promise<Types.PostV2ApiCompanyIdSpendLimitsResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/spend-limits/`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 403, 404, 409];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 403 | 404 | 409,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 403 | 404 | 409,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdSpendLimits: SpendeskApi['postV2ApiCompanyIdSpendLimits'] =
  async (
    request: Types.PostV2ApiCompanyIdSpendLimitsRequest,
  ): Promise<Types.PostV2ApiCompanyIdSpendLimitsResponses> => {
    return await _postV2ApiCompanyIdSpendLimits(baseUrl, request);
  };
const _deleteV2ApiCompanyIdSpendLimitsSpendLimitId = async (
  url: string,
  request: Types.DeleteV2ApiCompanyIdSpendLimitsSpendLimitIdRequest,
): Promise<Types.DeleteV2ApiCompanyIdSpendLimitsSpendLimitIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/spend-limits/${request.path['spendLimitId']}`,
    {
      method: 'DELETE',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 403, 404];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 403 | 404,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 403 | 404,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const deleteV2ApiCompanyIdSpendLimitsSpendLimitId: SpendeskApi['deleteV2ApiCompanyIdSpendLimitsSpendLimitId'] =
  async (
    request: Types.DeleteV2ApiCompanyIdSpendLimitsSpendLimitIdRequest,
  ): Promise<Types.DeleteV2ApiCompanyIdSpendLimitsSpendLimitIdResponses> => {
    return await _deleteV2ApiCompanyIdSpendLimitsSpendLimitId(baseUrl, request);
  };
const _getV2ApiCompanyIdSpendLimitsSpendLimitId = async (
  url: string,
  request: Types.GetV2ApiCompanyIdSpendLimitsSpendLimitIdRequest,
): Promise<Types.GetV2ApiCompanyIdSpendLimitsSpendLimitIdResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/spend-limits/${request.path['spendLimitId']}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 403, 404];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 403 | 404,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 403 | 404,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdSpendLimitsSpendLimitId: SpendeskApi['getV2ApiCompanyIdSpendLimitsSpendLimitId'] =
  async (
    request: Types.GetV2ApiCompanyIdSpendLimitsSpendLimitIdRequest,
  ): Promise<Types.GetV2ApiCompanyIdSpendLimitsSpendLimitIdResponses> => {
    return await _getV2ApiCompanyIdSpendLimitsSpendLimitId(baseUrl, request);
  };
const _putV2ApiCompanyIdSpendLimitsSpendLimitId = async (
  url: string,
  request: Types.PutV2ApiCompanyIdSpendLimitsSpendLimitIdRequest,
): Promise<Types.PutV2ApiCompanyIdSpendLimitsSpendLimitIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/spend-limits/${request.path['spendLimitId']}`,
    {
      method: 'PUT',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 403, 404, 409];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 403 | 404 | 409,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 403 | 404 | 409,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const putV2ApiCompanyIdSpendLimitsSpendLimitId: SpendeskApi['putV2ApiCompanyIdSpendLimitsSpendLimitId'] =
  async (
    request: Types.PutV2ApiCompanyIdSpendLimitsSpendLimitIdRequest,
  ): Promise<Types.PutV2ApiCompanyIdSpendLimitsSpendLimitIdResponses> => {
    return await _putV2ApiCompanyIdSpendLimitsSpendLimitId(baseUrl, request);
  };
const _patchV2ApiCompanyIdTransferSchedulingBillsBillId = async (
  url: string,
  request: Types.PatchV2ApiCompanyIdTransferSchedulingBillsBillIdRequest,
): Promise<Types.PatchV2ApiCompanyIdTransferSchedulingBillsBillIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/transfer-scheduling/bills/${request.path['billId']}`,
    {
      method: 'PATCH',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const patchV2ApiCompanyIdTransferSchedulingBillsBillId: SpendeskApi['patchV2ApiCompanyIdTransferSchedulingBillsBillId'] =
  async (
    request: Types.PatchV2ApiCompanyIdTransferSchedulingBillsBillIdRequest,
  ): Promise<Types.PatchV2ApiCompanyIdTransferSchedulingBillsBillIdResponses> => {
    return await _patchV2ApiCompanyIdTransferSchedulingBillsBillId(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdUserDelegationsDelegatees = async (
  url: string,
  request: Types.GetV2ApiCompanyIdUserDelegationsDelegateesRequest,
): Promise<Types.GetV2ApiCompanyIdUserDelegationsDelegateesResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdUserDelegationsDelegateesRequest['query']
  >)[] = ['active', 'orderingKey', 'orderingOrder', 'enrichDelegateeUser'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/user-delegations/delegatees?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdUserDelegationsDelegatees: SpendeskApi['getV2ApiCompanyIdUserDelegationsDelegatees'] =
  async (
    request: Types.GetV2ApiCompanyIdUserDelegationsDelegateesRequest,
  ): Promise<Types.GetV2ApiCompanyIdUserDelegationsDelegateesResponses> => {
    return await _getV2ApiCompanyIdUserDelegationsDelegatees(baseUrl, request);
  };
const _putV2ApiCompanyIdUserDelegationsDelegatees = async (
  url: string,
  request: Types.PutV2ApiCompanyIdUserDelegationsDelegateesRequest,
): Promise<Types.PutV2ApiCompanyIdUserDelegationsDelegateesResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/user-delegations/delegatees`,
    {
      method: 'PUT',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  if (response.status === 204) {
    return {
      statusCode: response.status,
      headers: headersToJSON(response.headers),
      body: undefined,
    };
  }
  const jsonResponses = [400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 204 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const putV2ApiCompanyIdUserDelegationsDelegatees: SpendeskApi['putV2ApiCompanyIdUserDelegationsDelegatees'] =
  async (
    request: Types.PutV2ApiCompanyIdUserDelegationsDelegateesRequest,
  ): Promise<Types.PutV2ApiCompanyIdUserDelegationsDelegateesResponses> => {
    return await _putV2ApiCompanyIdUserDelegationsDelegatees(baseUrl, request);
  };
const _getV2ApiCompanyIdUserDelegationsDelegators = async (
  url: string,
  request: Types.GetV2ApiCompanyIdUserDelegationsDelegatorsRequest,
): Promise<Types.GetV2ApiCompanyIdUserDelegationsDelegatorsResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdUserDelegationsDelegatorsRequest['query']
  >)[] = ['active', 'orderingKey', 'orderingOrder', 'enrichDelegatorUser'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/user-delegations/delegators?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdUserDelegationsDelegators: SpendeskApi['getV2ApiCompanyIdUserDelegationsDelegators'] =
  async (
    request: Types.GetV2ApiCompanyIdUserDelegationsDelegatorsRequest,
  ): Promise<Types.GetV2ApiCompanyIdUserDelegationsDelegatorsResponses> => {
    return await _getV2ApiCompanyIdUserDelegationsDelegators(baseUrl, request);
  };
const _postV2ApiCompanyIdUsersManagerAssociations = async (
  url: string,
  request: Types.PostV2ApiCompanyIdUsersManagerAssociationsRequest,
): Promise<Types.PostV2ApiCompanyIdUsersManagerAssociationsResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/users/manager-associations`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdUsersManagerAssociations: SpendeskApi['postV2ApiCompanyIdUsersManagerAssociations'] =
  async (
    request: Types.PostV2ApiCompanyIdUsersManagerAssociationsRequest,
  ): Promise<Types.PostV2ApiCompanyIdUsersManagerAssociationsResponses> => {
    return await _postV2ApiCompanyIdUsersManagerAssociations(baseUrl, request);
  };
const _getV2ApiCompanyIdUsersUserIdAuthenticationFactors = async (
  url: string,
  request: Types.GetV2ApiCompanyIdUsersUserIdAuthenticationFactorsRequest,
): Promise<Types.GetV2ApiCompanyIdUsersUserIdAuthenticationFactorsResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/users/${request.path['userId']}/authentication-factors/`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdUsersUserIdAuthenticationFactors: SpendeskApi['getV2ApiCompanyIdUsersUserIdAuthenticationFactors'] =
  async (
    request: Types.GetV2ApiCompanyIdUsersUserIdAuthenticationFactorsRequest,
  ): Promise<Types.GetV2ApiCompanyIdUsersUserIdAuthenticationFactorsResponses> => {
    return await _getV2ApiCompanyIdUsersUserIdAuthenticationFactors(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryInitiate =
  async (
    url: string,
    request: Types.PostV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryInitiateRequest,
  ): Promise<Types.PostV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryInitiateResponses> => {
    const body = 'body' in request ? request.body : undefined;
    const isFormData = body instanceof FormData;
    const headers: HeadersInit = {
      ...defaultHeaders,
      ...(isFormData || body === undefined ? {} : defaultJsonType),
    };

    const response = await fetch(
      `${url}/v2/api/${request.path['companyId']}/users/${request.path['userId']}/authentication-factors/recovery/initiate`,
      {
        method: 'POST',
        body: isFormData ? body : JSON.stringify(body),
        credentials: 'include',
        headers,
        ...defaultFetchParams,
      },
    );

    const jsonResponses = [200, 400, 401, 403, 404, 500];
    if (jsonResponses.includes(response.status)) {
      return {
        statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
        headers: headersToJSON(response.headers),
        body: await response.json(),
      };
    }
    const responseType = response.headers
      .get('content-type')
      ?.startsWith('application/json')
      ? 'json'
      : 'text';
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response[responseType](),
    };
  };

export const postV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryInitiate: SpendeskApi['postV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryInitiate'] =
  async (
    request: Types.PostV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryInitiateRequest,
  ): Promise<Types.PostV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryInitiateResponses> => {
    return await _postV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryInitiate(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryProcedureIdVerify =
  async (
    url: string,
    request: Types.PostV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryProcedureIdVerifyRequest,
  ): Promise<Types.PostV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryProcedureIdVerifyResponses> => {
    const body = 'body' in request ? request.body : undefined;
    const isFormData = body instanceof FormData;
    const headers: HeadersInit = {
      ...defaultHeaders,
      ...(isFormData || body === undefined ? {} : defaultJsonType),
    };

    const response = await fetch(
      `${url}/v2/api/${request.path['companyId']}/users/${request.path['userId']}/authentication-factors/recovery/${request.path['procedureId']}/verify`,
      {
        method: 'POST',
        body: isFormData ? body : JSON.stringify(body),
        credentials: 'include',
        headers,
        ...defaultFetchParams,
      },
    );

    const jsonResponses = [200, 400, 401, 403, 404, 500];
    if (jsonResponses.includes(response.status)) {
      return {
        statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
        headers: headersToJSON(response.headers),
        body: await response.json(),
      };
    }
    const responseType = response.headers
      .get('content-type')
      ?.startsWith('application/json')
      ? 'json'
      : 'text';
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response[responseType](),
    };
  };

export const postV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryProcedureIdVerify: SpendeskApi['postV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryProcedureIdVerify'] =
  async (
    request: Types.PostV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryProcedureIdVerifyRequest,
  ): Promise<Types.PostV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryProcedureIdVerifyResponses> => {
    return await _postV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryProcedureIdVerify(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdUsersUserIdManagerAssociations = async (
  url: string,
  request: Types.PostV2ApiCompanyIdUsersUserIdManagerAssociationsRequest,
): Promise<Types.PostV2ApiCompanyIdUsersUserIdManagerAssociationsResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/users/${request.path['userId']}/manager-associations`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdUsersUserIdManagerAssociations: SpendeskApi['postV2ApiCompanyIdUsersUserIdManagerAssociations'] =
  async (
    request: Types.PostV2ApiCompanyIdUsersUserIdManagerAssociationsRequest,
  ): Promise<Types.PostV2ApiCompanyIdUsersUserIdManagerAssociationsResponses> => {
    return await _postV2ApiCompanyIdUsersUserIdManagerAssociations(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdVerificationsOfPayees = async (
  url: string,
  request: Types.PostV2ApiCompanyIdVerificationsOfPayeesRequest,
): Promise<Types.PostV2ApiCompanyIdVerificationsOfPayeesResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/verifications-of-payees`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500, 502];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500 | 502,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdVerificationsOfPayees: SpendeskApi['postV2ApiCompanyIdVerificationsOfPayees'] =
  async (
    request: Types.PostV2ApiCompanyIdVerificationsOfPayeesRequest,
  ): Promise<Types.PostV2ApiCompanyIdVerificationsOfPayeesResponses> => {
    return await _postV2ApiCompanyIdVerificationsOfPayees(baseUrl, request);
  };
const _getV2ApiCompanyIdWalletClosedLoopAccounts = async (
  url: string,
  request: Types.GetV2ApiCompanyIdWalletClosedLoopAccountsRequest,
): Promise<Types.GetV2ApiCompanyIdWalletClosedLoopAccountsResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/wallet/closed-loop-accounts`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 404];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 404,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 404,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdWalletClosedLoopAccounts: SpendeskApi['getV2ApiCompanyIdWalletClosedLoopAccounts'] =
  async (
    request: Types.GetV2ApiCompanyIdWalletClosedLoopAccountsRequest,
  ): Promise<Types.GetV2ApiCompanyIdWalletClosedLoopAccountsResponses> => {
    return await _getV2ApiCompanyIdWalletClosedLoopAccounts(baseUrl, request);
  };
const _postV2ApiCompanyIdWalletWithdrawals = async (
  url: string,
  request: Types.PostV2ApiCompanyIdWalletWithdrawalsRequest,
): Promise<Types.PostV2ApiCompanyIdWalletWithdrawalsResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/wallet/withdrawals/`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [202, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 202 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 202 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdWalletWithdrawals: SpendeskApi['postV2ApiCompanyIdWalletWithdrawals'] =
  async (
    request: Types.PostV2ApiCompanyIdWalletWithdrawalsRequest,
  ): Promise<Types.PostV2ApiCompanyIdWalletWithdrawalsResponses> => {
    return await _postV2ApiCompanyIdWalletWithdrawals(baseUrl, request);
  };
const _getV2ApiCompanyIdWalletWithdrawalsWithdrawalIdStatus = async (
  url: string,
  request: Types.GetV2ApiCompanyIdWalletWithdrawalsWithdrawalIdStatusRequest,
): Promise<Types.GetV2ApiCompanyIdWalletWithdrawalsWithdrawalIdStatusResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/wallet/withdrawals/${request.path['withdrawalId']}/status`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdWalletWithdrawalsWithdrawalIdStatus: SpendeskApi['getV2ApiCompanyIdWalletWithdrawalsWithdrawalIdStatus'] =
  async (
    request: Types.GetV2ApiCompanyIdWalletWithdrawalsWithdrawalIdStatusRequest,
  ): Promise<Types.GetV2ApiCompanyIdWalletWithdrawalsWithdrawalIdStatusResponses> => {
    return await _getV2ApiCompanyIdWalletWithdrawalsWithdrawalIdStatus(
      baseUrl,
      request,
    );
  };
const _getV2ApiOrganisationIdSettings = async (
  url: string,
  request: Types.GetV2ApiOrganisationIdSettingsRequest,
): Promise<Types.GetV2ApiOrganisationIdSettingsResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['organisationId']}/settings/`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 403];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 403,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 403,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiOrganisationIdSettings: SpendeskApi['getV2ApiOrganisationIdSettings'] =
  async (
    request: Types.GetV2ApiOrganisationIdSettingsRequest,
  ): Promise<Types.GetV2ApiOrganisationIdSettingsResponses> => {
    return await _getV2ApiOrganisationIdSettings(baseUrl, request);
  };
const _postV2ApiOrganisationIdSettings = async (
  url: string,
  request: Types.PostV2ApiOrganisationIdSettingsRequest,
): Promise<Types.PostV2ApiOrganisationIdSettingsResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['organisationId']}/settings/`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 403];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 403,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 403,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiOrganisationIdSettings: SpendeskApi['postV2ApiOrganisationIdSettings'] =
  async (
    request: Types.PostV2ApiOrganisationIdSettingsRequest,
  ): Promise<Types.PostV2ApiOrganisationIdSettingsResponses> => {
    return await _postV2ApiOrganisationIdSettings(baseUrl, request);
  };
const _getV2ApiOrganisationIdSettingsAccess = async (
  url: string,
  request: Types.GetV2ApiOrganisationIdSettingsAccessRequest,
): Promise<Types.GetV2ApiOrganisationIdSettingsAccessResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['organisationId']}/settings/access`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiOrganisationIdSettingsAccess: SpendeskApi['getV2ApiOrganisationIdSettingsAccess'] =
  async (
    request: Types.GetV2ApiOrganisationIdSettingsAccessRequest,
  ): Promise<Types.GetV2ApiOrganisationIdSettingsAccessResponses> => {
    return await _getV2ApiOrganisationIdSettingsAccess(baseUrl, request);
  };
const _postV2ApiOrganisationIdSettingsBulkDelete = async (
  url: string,
  request: Types.PostV2ApiOrganisationIdSettingsBulkDeleteRequest,
): Promise<Types.PostV2ApiOrganisationIdSettingsBulkDeleteResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['organisationId']}/settings/bulk-delete`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 403, 404];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 403 | 404,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 403 | 404,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiOrganisationIdSettingsBulkDelete: SpendeskApi['postV2ApiOrganisationIdSettingsBulkDelete'] =
  async (
    request: Types.PostV2ApiOrganisationIdSettingsBulkDeleteRequest,
  ): Promise<Types.PostV2ApiOrganisationIdSettingsBulkDeleteResponses> => {
    return await _postV2ApiOrganisationIdSettingsBulkDelete(baseUrl, request);
  };
const _postV2ApiOrganisationIdSettingsMerge = async (
  url: string,
  request: Types.PostV2ApiOrganisationIdSettingsMergeRequest,
): Promise<Types.PostV2ApiOrganisationIdSettingsMergeResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['organisationId']}/settings/merge`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 403];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 403,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 403,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiOrganisationIdSettingsMerge: SpendeskApi['postV2ApiOrganisationIdSettingsMerge'] =
  async (
    request: Types.PostV2ApiOrganisationIdSettingsMergeRequest,
  ): Promise<Types.PostV2ApiOrganisationIdSettingsMergeResponses> => {
    return await _postV2ApiOrganisationIdSettingsMerge(baseUrl, request);
  };
const _postV2ApiOrganisationIdSettingsMigrate = async (
  url: string,
  request: Types.PostV2ApiOrganisationIdSettingsMigrateRequest,
): Promise<Types.PostV2ApiOrganisationIdSettingsMigrateResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['organisationId']}/settings/migrate`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 403, 404];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 403 | 404,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 403 | 404,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiOrganisationIdSettingsMigrate: SpendeskApi['postV2ApiOrganisationIdSettingsMigrate'] =
  async (
    request: Types.PostV2ApiOrganisationIdSettingsMigrateRequest,
  ): Promise<Types.PostV2ApiOrganisationIdSettingsMigrateResponses> => {
    return await _postV2ApiOrganisationIdSettingsMigrate(baseUrl, request);
  };
const _deleteV2ApiOrganisationIdSettingsSettingsId = async (
  url: string,
  request: Types.DeleteV2ApiOrganisationIdSettingsSettingsIdRequest,
): Promise<Types.DeleteV2ApiOrganisationIdSettingsSettingsIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['organisationId']}/settings/${request.path['settingsId']}`,
    {
      method: 'DELETE',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 403, 404];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 403 | 404,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 403 | 404,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const deleteV2ApiOrganisationIdSettingsSettingsId: SpendeskApi['deleteV2ApiOrganisationIdSettingsSettingsId'] =
  async (
    request: Types.DeleteV2ApiOrganisationIdSettingsSettingsIdRequest,
  ): Promise<Types.DeleteV2ApiOrganisationIdSettingsSettingsIdResponses> => {
    return await _deleteV2ApiOrganisationIdSettingsSettingsId(baseUrl, request);
  };
const _patchV2ApiOrganisationIdSettingsSettingsId = async (
  url: string,
  request: Types.PatchV2ApiOrganisationIdSettingsSettingsIdRequest,
): Promise<Types.PatchV2ApiOrganisationIdSettingsSettingsIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['organisationId']}/settings/${request.path['settingsId']}`,
    {
      method: 'PATCH',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 403, 404];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 403 | 404,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 403 | 404,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const patchV2ApiOrganisationIdSettingsSettingsId: SpendeskApi['patchV2ApiOrganisationIdSettingsSettingsId'] =
  async (
    request: Types.PatchV2ApiOrganisationIdSettingsSettingsIdRequest,
  ): Promise<Types.PatchV2ApiOrganisationIdSettingsSettingsIdResponses> => {
    return await _patchV2ApiOrganisationIdSettingsSettingsId(baseUrl, request);
  };
const _getV2HealthCheck = async (
  url: string,
  request: Types.GetV2HealthCheckRequest,
): Promise<Types.GetV2HealthCheckResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(`${url}/v2/health-check`, {
    credentials: 'include',
    headers,
    ...defaultFetchParams,
  });

  const jsonResponses = [200];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2HealthCheck: SpendeskApi['getV2HealthCheck'] = async (
  request: Types.GetV2HealthCheckRequest,
): Promise<Types.GetV2HealthCheckResponses> => {
  return await _getV2HealthCheck(baseUrl, request);
};
const _postV2ApiCompanyIdTravelPropertiesAccommodationSuggestions = async (
  url: string,
  request: Types.PostV2ApiCompanyIdTravelPropertiesAccommodationSuggestionsRequest,
): Promise<Types.PostV2ApiCompanyIdTravelPropertiesAccommodationSuggestionsResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/travel/properties/accommodation-suggestions`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdTravelPropertiesAccommodationSuggestions: SpendeskApi['postV2ApiCompanyIdTravelPropertiesAccommodationSuggestions'] =
  async (
    request: Types.PostV2ApiCompanyIdTravelPropertiesAccommodationSuggestionsRequest,
  ): Promise<Types.PostV2ApiCompanyIdTravelPropertiesAccommodationSuggestionsResponses> => {
    return await _postV2ApiCompanyIdTravelPropertiesAccommodationSuggestions(
      baseUrl,
      request,
    );
  };
const _postV2ApiCompanyIdTravelPropertiesSearch = async (
  url: string,
  request: Types.PostV2ApiCompanyIdTravelPropertiesSearchRequest,
): Promise<Types.PostV2ApiCompanyIdTravelPropertiesSearchResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/travel/properties/search`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [201, 400, 401, 403, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 201 | 400 | 401 | 403 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 201 | 400 | 401 | 403 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdTravelPropertiesSearch: SpendeskApi['postV2ApiCompanyIdTravelPropertiesSearch'] =
  async (
    request: Types.PostV2ApiCompanyIdTravelPropertiesSearchRequest,
  ): Promise<Types.PostV2ApiCompanyIdTravelPropertiesSearchResponses> => {
    return await _postV2ApiCompanyIdTravelPropertiesSearch(baseUrl, request);
  };
const _getV2ApiCompanyIdTravelPropertiesSessionSessionIdResults = async (
  url: string,
  request: Types.GetV2ApiCompanyIdTravelPropertiesSessionSessionIdResultsRequest,
): Promise<Types.GetV2ApiCompanyIdTravelPropertiesSessionSessionIdResultsResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdTravelPropertiesSessionSessionIdResultsRequest['query']
  >)[] = ['cursor', 'pageSize'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/travel/properties/session/${request.path['sessionId']}/results?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 404, 410, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 410 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 410 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdTravelPropertiesSessionSessionIdResults: SpendeskApi['getV2ApiCompanyIdTravelPropertiesSessionSessionIdResults'] =
  async (
    request: Types.GetV2ApiCompanyIdTravelPropertiesSessionSessionIdResultsRequest,
  ): Promise<Types.GetV2ApiCompanyIdTravelPropertiesSessionSessionIdResultsResponses> => {
    return await _getV2ApiCompanyIdTravelPropertiesSessionSessionIdResults(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdTravelPropertiesPropertyOfferIdOffers = async (
  url: string,
  request: Types.GetV2ApiCompanyIdTravelPropertiesPropertyOfferIdOffersRequest,
): Promise<Types.GetV2ApiCompanyIdTravelPropertiesPropertyOfferIdOffersResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/travel/properties/${request.path['propertyOfferId']}/offers`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 404, 500, 502];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500 | 502,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500 | 502,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdTravelPropertiesPropertyOfferIdOffers: SpendeskApi['getV2ApiCompanyIdTravelPropertiesPropertyOfferIdOffers'] =
  async (
    request: Types.GetV2ApiCompanyIdTravelPropertiesPropertyOfferIdOffersRequest,
  ): Promise<Types.GetV2ApiCompanyIdTravelPropertiesPropertyOfferIdOffersResponses> => {
    return await _getV2ApiCompanyIdTravelPropertiesPropertyOfferIdOffers(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdTravelTrips = async (
  url: string,
  request: Types.GetV2ApiCompanyIdTravelTripsRequest,
): Promise<Types.GetV2ApiCompanyIdTravelTripsResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdTravelTripsRequest['query']
  >)[] = ['enrichBudgets'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/travel/trips/?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdTravelTrips: SpendeskApi['getV2ApiCompanyIdTravelTrips'] =
  async (
    request: Types.GetV2ApiCompanyIdTravelTripsRequest,
  ): Promise<Types.GetV2ApiCompanyIdTravelTripsResponses> => {
    return await _getV2ApiCompanyIdTravelTrips(baseUrl, request);
  };
const _postV2ApiCompanyIdTravelTrips = async (
  url: string,
  request: Types.PostV2ApiCompanyIdTravelTripsRequest,
): Promise<Types.PostV2ApiCompanyIdTravelTripsResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.PostV2ApiCompanyIdTravelTripsRequest['query']
  >)[] = ['enrichBudgets'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/travel/trips/?${searchParams.toString()}`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdTravelTrips: SpendeskApi['postV2ApiCompanyIdTravelTrips'] =
  async (
    request: Types.PostV2ApiCompanyIdTravelTripsRequest,
  ): Promise<Types.PostV2ApiCompanyIdTravelTripsResponses> => {
    return await _postV2ApiCompanyIdTravelTrips(baseUrl, request);
  };
const _getV2ApiCompanyIdTravelTripsCurrent = async (
  url: string,
  request: Types.GetV2ApiCompanyIdTravelTripsCurrentRequest,
): Promise<Types.GetV2ApiCompanyIdTravelTripsCurrentResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdTravelTripsCurrentRequest['query']
  >)[] = ['userId', 'enrichBudgets'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };
  if (
    request.headers &&
    request.headers['x-impersonated-user-id'] !== undefined
  ) {
    headers['x-impersonated-user-id'] =
      request.headers['x-impersonated-user-id'];
    delete request.headers['x-impersonated-user-id'];
  }
  if (request.headers && request.headers['x-spdk-request-id'] !== undefined) {
    headers['x-spdk-request-id'] = request.headers['x-spdk-request-id'];
    delete request.headers['x-spdk-request-id'];
  }

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/travel/trips/current?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdTravelTripsCurrent: SpendeskApi['getV2ApiCompanyIdTravelTripsCurrent'] =
  async (
    request: Types.GetV2ApiCompanyIdTravelTripsCurrentRequest,
  ): Promise<Types.GetV2ApiCompanyIdTravelTripsCurrentResponses> => {
    return await _getV2ApiCompanyIdTravelTripsCurrent(baseUrl, request);
  };
const _getV2ApiCompanyIdTravelTripsTripId = async (
  url: string,
  request: Types.GetV2ApiCompanyIdTravelTripsTripIdRequest,
): Promise<Types.GetV2ApiCompanyIdTravelTripsTripIdResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdTravelTripsTripIdRequest['query']
  >)[] = ['enrichBookings', 'enrichBudgets'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };
  if (
    request.headers &&
    request.headers['x-impersonated-user-id'] !== undefined
  ) {
    headers['x-impersonated-user-id'] =
      request.headers['x-impersonated-user-id'];
    delete request.headers['x-impersonated-user-id'];
  }
  if (request.headers && request.headers['x-spdk-request-id'] !== undefined) {
    headers['x-spdk-request-id'] = request.headers['x-spdk-request-id'];
    delete request.headers['x-spdk-request-id'];
  }

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/travel/trips/${request.path['tripId']}?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdTravelTripsTripId: SpendeskApi['getV2ApiCompanyIdTravelTripsTripId'] =
  async (
    request: Types.GetV2ApiCompanyIdTravelTripsTripIdRequest,
  ): Promise<Types.GetV2ApiCompanyIdTravelTripsTripIdResponses> => {
    return await _getV2ApiCompanyIdTravelTripsTripId(baseUrl, request);
  };
const _postV2ApiCompanyIdTravelTripsTripIdBookingsProperty = async (
  url: string,
  request: Types.PostV2ApiCompanyIdTravelTripsTripIdBookingsPropertyRequest,
): Promise<Types.PostV2ApiCompanyIdTravelTripsTripIdBookingsPropertyResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };
  if (
    request.headers &&
    request.headers['x-impersonated-user-id'] !== undefined
  ) {
    headers['x-impersonated-user-id'] =
      request.headers['x-impersonated-user-id'];
    delete request.headers['x-impersonated-user-id'];
  }
  if (request.headers && request.headers['x-spdk-request-id'] !== undefined) {
    headers['x-spdk-request-id'] = request.headers['x-spdk-request-id'];
    delete request.headers['x-spdk-request-id'];
  }

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/travel/trips/${request.path['tripId']}/bookings/property/`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 404, 422, 500, 502];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as
        | 200
        | 400
        | 401
        | 403
        | 404
        | 422
        | 500
        | 502,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as
      | 200
      | 400
      | 401
      | 403
      | 404
      | 422
      | 500
      | 502,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdTravelTripsTripIdBookingsProperty: SpendeskApi['postV2ApiCompanyIdTravelTripsTripIdBookingsProperty'] =
  async (
    request: Types.PostV2ApiCompanyIdTravelTripsTripIdBookingsPropertyRequest,
  ): Promise<Types.PostV2ApiCompanyIdTravelTripsTripIdBookingsPropertyResponses> => {
    return await _postV2ApiCompanyIdTravelTripsTripIdBookingsProperty(
      baseUrl,
      request,
    );
  };
const _deleteV2ApiCompanyIdTravelTripsTripIdBookingsBookingId = async (
  url: string,
  request: Types.DeleteV2ApiCompanyIdTravelTripsTripIdBookingsBookingIdRequest,
): Promise<Types.DeleteV2ApiCompanyIdTravelTripsTripIdBookingsBookingIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };
  if (
    request.headers &&
    request.headers['x-impersonated-user-id'] !== undefined
  ) {
    headers['x-impersonated-user-id'] =
      request.headers['x-impersonated-user-id'];
    delete request.headers['x-impersonated-user-id'];
  }
  if (request.headers && request.headers['x-spdk-request-id'] !== undefined) {
    headers['x-spdk-request-id'] = request.headers['x-spdk-request-id'];
    delete request.headers['x-spdk-request-id'];
  }

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/travel/trips/${request.path['tripId']}/bookings/${request.path['bookingId']}`,
    {
      method: 'DELETE',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  if (response.status === 204) {
    return {
      statusCode: response.status,
      headers: headersToJSON(response.headers),
      body: undefined,
    };
  }
  const jsonResponses = [204, 400, 401, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 204 | 400 | 401 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 204 | 400 | 401 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const deleteV2ApiCompanyIdTravelTripsTripIdBookingsBookingId: SpendeskApi['deleteV2ApiCompanyIdTravelTripsTripIdBookingsBookingId'] =
  async (
    request: Types.DeleteV2ApiCompanyIdTravelTripsTripIdBookingsBookingIdRequest,
  ): Promise<Types.DeleteV2ApiCompanyIdTravelTripsTripIdBookingsBookingIdResponses> => {
    return await _deleteV2ApiCompanyIdTravelTripsTripIdBookingsBookingId(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdTravelTripsTripIdBookingsBookingIdProperty = async (
  url: string,
  request: Types.GetV2ApiCompanyIdTravelTripsTripIdBookingsBookingIdPropertyRequest,
): Promise<Types.GetV2ApiCompanyIdTravelTripsTripIdBookingsBookingIdPropertyResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };
  if (
    request.headers &&
    request.headers['x-impersonated-user-id'] !== undefined
  ) {
    headers['x-impersonated-user-id'] =
      request.headers['x-impersonated-user-id'];
    delete request.headers['x-impersonated-user-id'];
  }
  if (request.headers && request.headers['x-spdk-request-id'] !== undefined) {
    headers['x-spdk-request-id'] = request.headers['x-spdk-request-id'];
    delete request.headers['x-spdk-request-id'];
  }

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/travel/trips/${request.path['tripId']}/bookings/${request.path['bookingId']}/property`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdTravelTripsTripIdBookingsBookingIdProperty: SpendeskApi['getV2ApiCompanyIdTravelTripsTripIdBookingsBookingIdProperty'] =
  async (
    request: Types.GetV2ApiCompanyIdTravelTripsTripIdBookingsBookingIdPropertyRequest,
  ): Promise<Types.GetV2ApiCompanyIdTravelTripsTripIdBookingsBookingIdPropertyResponses> => {
    return await _getV2ApiCompanyIdTravelTripsTripIdBookingsBookingIdProperty(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdTravelTripsTripIdPayments = async (
  url: string,
  request: Types.GetV2ApiCompanyIdTravelTripsTripIdPaymentsRequest,
): Promise<Types.GetV2ApiCompanyIdTravelTripsTripIdPaymentsResponses> => {
  const headers: HeadersInit = {
    ...defaultHeaders,
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/travel/trips/${request.path['tripId']}/payments/`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdTravelTripsTripIdPayments: SpendeskApi['getV2ApiCompanyIdTravelTripsTripIdPayments'] =
  async (
    request: Types.GetV2ApiCompanyIdTravelTripsTripIdPaymentsRequest,
  ): Promise<Types.GetV2ApiCompanyIdTravelTripsTripIdPaymentsResponses> => {
    return await _getV2ApiCompanyIdTravelTripsTripIdPayments(baseUrl, request);
  };
const _postV2ApiCompanyIdTravelTripsTripIdPayments = async (
  url: string,
  request: Types.PostV2ApiCompanyIdTravelTripsTripIdPaymentsRequest,
): Promise<Types.PostV2ApiCompanyIdTravelTripsTripIdPaymentsResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/travel/trips/${request.path['tripId']}/payments/`,
    {
      method: 'POST',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 422, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 422 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 422 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const postV2ApiCompanyIdTravelTripsTripIdPayments: SpendeskApi['postV2ApiCompanyIdTravelTripsTripIdPayments'] =
  async (
    request: Types.PostV2ApiCompanyIdTravelTripsTripIdPaymentsRequest,
  ): Promise<Types.PostV2ApiCompanyIdTravelTripsTripIdPaymentsResponses> => {
    return await _postV2ApiCompanyIdTravelTripsTripIdPayments(baseUrl, request);
  };
const _deleteV2ApiCompanyIdTravelEntityTypeEntityIdTrip = async (
  url: string,
  request: Types.DeleteV2ApiCompanyIdTravelEntityTypeEntityIdTripRequest,
): Promise<Types.DeleteV2ApiCompanyIdTravelEntityTypeEntityIdTripResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };
  if (
    request.headers &&
    request.headers['x-impersonated-user-id'] !== undefined
  ) {
    headers['x-impersonated-user-id'] =
      request.headers['x-impersonated-user-id'];
    delete request.headers['x-impersonated-user-id'];
  }
  if (request.headers && request.headers['x-spdk-request-id'] !== undefined) {
    headers['x-spdk-request-id'] = request.headers['x-spdk-request-id'];
    delete request.headers['x-spdk-request-id'];
  }

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/travel/${request.path['entityType']}/${request.path['entityId']}/trip/`,
    {
      method: 'DELETE',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  if (response.status === 204) {
    return {
      statusCode: response.status,
      headers: headersToJSON(response.headers),
      body: undefined,
    };
  }
  const jsonResponses = [204, 400, 401, 403, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 204 | 400 | 401 | 403 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 204 | 400 | 401 | 403 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const deleteV2ApiCompanyIdTravelEntityTypeEntityIdTrip: SpendeskApi['deleteV2ApiCompanyIdTravelEntityTypeEntityIdTrip'] =
  async (
    request: Types.DeleteV2ApiCompanyIdTravelEntityTypeEntityIdTripRequest,
  ): Promise<Types.DeleteV2ApiCompanyIdTravelEntityTypeEntityIdTripResponses> => {
    return await _deleteV2ApiCompanyIdTravelEntityTypeEntityIdTrip(
      baseUrl,
      request,
    );
  };
const _getV2ApiCompanyIdTravelEntityTypeEntityIdTrip = async (
  url: string,
  request: Types.GetV2ApiCompanyIdTravelEntityTypeEntityIdTripRequest,
): Promise<Types.GetV2ApiCompanyIdTravelEntityTypeEntityIdTripResponses> => {
  const queryParameters: (keyof NonNullable<
    Types.GetV2ApiCompanyIdTravelEntityTypeEntityIdTripRequest['query']
  >)[] = ['enrichBudgets'];
  const searchParams = new URLSearchParams();
  if (request.query) {
    queryParameters.forEach((qp) => {
      const queryValue = request.query?.[qp];
      if (queryValue) {
        if (Array.isArray(queryValue)) {
          queryValue.forEach((p) => searchParams.append(qp, p));
        } else {
          searchParams.append(qp, queryValue.toString());
        }
      }
      delete request.query?.[qp];
    });
  }

  const headers: HeadersInit = {
    ...defaultHeaders,
  };
  if (
    request.headers &&
    request.headers['x-impersonated-user-id'] !== undefined
  ) {
    headers['x-impersonated-user-id'] =
      request.headers['x-impersonated-user-id'];
    delete request.headers['x-impersonated-user-id'];
  }
  if (request.headers && request.headers['x-spdk-request-id'] !== undefined) {
    headers['x-spdk-request-id'] = request.headers['x-spdk-request-id'];
    delete request.headers['x-spdk-request-id'];
  }

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/travel/${request.path['entityType']}/${request.path['entityId']}/trip/?${searchParams.toString()}`,
    {
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  if (response.status === 204) {
    return {
      statusCode: response.status,
      headers: headersToJSON(response.headers),
      body: undefined,
    };
  }
  const jsonResponses = [200, 204, 400, 401, 403, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 204 | 400 | 401 | 403 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 204 | 400 | 401 | 403 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const getV2ApiCompanyIdTravelEntityTypeEntityIdTrip: SpendeskApi['getV2ApiCompanyIdTravelEntityTypeEntityIdTrip'] =
  async (
    request: Types.GetV2ApiCompanyIdTravelEntityTypeEntityIdTripRequest,
  ): Promise<Types.GetV2ApiCompanyIdTravelEntityTypeEntityIdTripResponses> => {
    return await _getV2ApiCompanyIdTravelEntityTypeEntityIdTrip(
      baseUrl,
      request,
    );
  };
const _putV2ApiCompanyIdTravelEntityTypeEntityIdTripTripId = async (
  url: string,
  request: Types.PutV2ApiCompanyIdTravelEntityTypeEntityIdTripTripIdRequest,
): Promise<Types.PutV2ApiCompanyIdTravelEntityTypeEntityIdTripTripIdResponses> => {
  const body = 'body' in request ? request.body : undefined;
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {
    ...defaultHeaders,
    ...(isFormData || body === undefined ? {} : defaultJsonType),
  };
  if (
    request.headers &&
    request.headers['x-impersonated-user-id'] !== undefined
  ) {
    headers['x-impersonated-user-id'] =
      request.headers['x-impersonated-user-id'];
    delete request.headers['x-impersonated-user-id'];
  }
  if (request.headers && request.headers['x-spdk-request-id'] !== undefined) {
    headers['x-spdk-request-id'] = request.headers['x-spdk-request-id'];
    delete request.headers['x-spdk-request-id'];
  }

  const response = await fetch(
    `${url}/v2/api/${request.path['companyId']}/travel/${request.path['entityType']}/${request.path['entityId']}/trip/${request.path['tripId']}`,
    {
      method: 'PUT',
      body: isFormData ? body : JSON.stringify(body),
      credentials: 'include',
      headers,
      ...defaultFetchParams,
    },
  );

  const jsonResponses = [200, 400, 401, 403, 404, 500];
  if (jsonResponses.includes(response.status)) {
    return {
      statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
      headers: headersToJSON(response.headers),
      body: await response.json(),
    };
  }
  const responseType = response.headers
    .get('content-type')
    ?.startsWith('application/json')
    ? 'json'
    : 'text';
  return {
    statusCode: response.status as 200 | 400 | 401 | 403 | 404 | 500,
    headers: headersToJSON(response.headers),
    body: await response[responseType](),
  };
};

export const putV2ApiCompanyIdTravelEntityTypeEntityIdTripTripId: SpendeskApi['putV2ApiCompanyIdTravelEntityTypeEntityIdTripTripId'] =
  async (
    request: Types.PutV2ApiCompanyIdTravelEntityTypeEntityIdTripTripIdRequest,
  ): Promise<Types.PutV2ApiCompanyIdTravelEntityTypeEntityIdTripTripIdResponses> => {
    return await _putV2ApiCompanyIdTravelEntityTypeEntityIdTripTripId(
      baseUrl,
      request,
    );
  };
type BuildOptions = {
  headers?: object;
};
export default function build(url: string, options?: BuildOptions) {
  url = sanitizeUrl(url);
  if (options?.headers) {
    defaultHeaders = options.headers;
  }
  return {
    getV2ApiAssetsSuppliersLogo: _getV2ApiAssetsSuppliersLogo.bind(
      url,
      ...arguments,
    ),
    postV2ApiAuthPasswordValidity: _postV2ApiAuthPasswordValidity.bind(
      url,
      ...arguments,
    ),
    postV2ApiAuthUserVerificationValidate:
      _postV2ApiAuthUserVerificationValidate.bind(url, ...arguments),
    postV2ApiAuthUserVerificationValidationLinkForwardToPhone:
      _postV2ApiAuthUserVerificationValidationLinkForwardToPhone.bind(
        url,
        ...arguments,
      ),
    getV2ApiAuthenticationFactors: _getV2ApiAuthenticationFactors.bind(
      url,
      ...arguments,
    ),
    postV2ApiAuthenticationFactors: _postV2ApiAuthenticationFactors.bind(
      url,
      ...arguments,
    ),
    deleteV2ApiAuthenticationFactorsFactorId:
      _deleteV2ApiAuthenticationFactorsFactorId.bind(url, ...arguments),
    postV2ApiAuthenticationFactorsFactorIdFinalize:
      _postV2ApiAuthenticationFactorsFactorIdFinalize.bind(url, ...arguments),
    postV2ApiAuthenticationOperationsOperationId:
      _postV2ApiAuthenticationOperationsOperationId.bind(url, ...arguments),
    postV2ApiCardsPaymentPasswordReset:
      _postV2ApiCardsPaymentPasswordReset.bind(url, ...arguments),
    postV2ApiCardsPaymentPasswordShow: _postV2ApiCardsPaymentPasswordShow.bind(
      url,
      ...arguments,
    ),
    postV2ApiCardsPaymentPasswordProcedureId:
      _postV2ApiCardsPaymentPasswordProcedureId.bind(url, ...arguments),
    getV2ApiCurrencies: _getV2ApiCurrencies.bind(url, ...arguments),
    getV2ApiExpenseBeneficiaries: _getV2ApiExpenseBeneficiaries.bind(
      url,
      ...arguments,
    ),
    getV2ApiGeoPlaces: _getV2ApiGeoPlaces.bind(url, ...arguments),
    getV2ApiScaAuthenticationFactors: _getV2ApiScaAuthenticationFactors.bind(
      url,
      ...arguments,
    ),
    postV2ApiScaAuthenticationOperationsValidateProcedureWithTotp:
      _postV2ApiScaAuthenticationOperationsValidateProcedureWithTotp.bind(
        url,
        ...arguments,
      ),
    postV2ApiTrustedDeviceValidate: _postV2ApiTrustedDeviceValidate.bind(
      url,
      ...arguments,
    ),
    deleteV2ApiTrustedDeviceTrustedDeviceId:
      _deleteV2ApiTrustedDeviceTrustedDeviceId.bind(url, ...arguments),
    getV2ApiTrustedDevices: _getV2ApiTrustedDevices.bind(url, ...arguments),
    getV2ApiCompanyIdAccountingIntegrationsAccountingSoftware:
      _getV2ApiCompanyIdAccountingIntegrationsAccountingSoftware.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFields:
      _getV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFields.bind(
        url,
        ...arguments,
      ),
    postV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFields:
      _postV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFields.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfiguration:
      _getV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfiguration.bind(
        url,
        ...arguments,
      ),
    putV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfiguration:
      _putV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsConfiguration.bind(
        url,
        ...arguments,
      ),
    putV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsFieldId:
      _putV2ApiCompanyIdAccountingIntegrationsMappingAnalyticalFieldsFieldId.bind(
        url,
        ...arguments,
      ),
    postV2ApiCompanyIdAccountingIntegrationsSyncOperations:
      _postV2ApiCompanyIdAccountingIntegrationsSyncOperations.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdAccountingIntegrationsSyncOperationsSyncMode:
      _getV2ApiCompanyIdAccountingIntegrationsSyncOperationsSyncMode.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdAccountingIntegrationsSyncSettings:
      _getV2ApiCompanyIdAccountingIntegrationsSyncSettings.bind(
        url,
        ...arguments,
      ),
    deleteV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldId:
      _deleteV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldId.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldId:
      _getV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldId.bind(
        url,
        ...arguments,
      ),
    putV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldId:
      _putV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldId.bind(
        url,
        ...arguments,
      ),
    postV2ApiCompanyIdApprovalWorkflows:
      _postV2ApiCompanyIdApprovalWorkflows.bind(url, ...arguments),
    getV2ApiCompanyIdApprovalWorkflowsActive:
      _getV2ApiCompanyIdApprovalWorkflowsActive.bind(url, ...arguments),
    postV2ApiCompanyIdApprovalWorkflowsMigrate:
      _postV2ApiCompanyIdApprovalWorkflowsMigrate.bind(url, ...arguments),
    putV2ApiCompanyIdApprovalWorkflowsWorkflowId:
      _putV2ApiCompanyIdApprovalWorkflowsWorkflowId.bind(url, ...arguments),
    postV2ApiCompanyIdAutomationAiGenerateBudget:
      _postV2ApiCompanyIdAutomationAiGenerateBudget.bind(url, ...arguments),
    getV2ApiCompanyIdBookkeepingDownloadId:
      _getV2ApiCompanyIdBookkeepingDownloadId.bind(url, ...arguments),
    getV2ApiCompanyIdBookkeepingPayablesInboxVersion:
      _getV2ApiCompanyIdBookkeepingPayablesInboxVersion.bind(url, ...arguments),
    getV2ApiCompanyIdBookkeepingSpainClosurePeriods:
      _getV2ApiCompanyIdBookkeepingSpainClosurePeriods.bind(url, ...arguments),
    postV2ApiCompanyIdBookkeepingSpainClosurePeriods:
      _postV2ApiCompanyIdBookkeepingSpainClosurePeriods.bind(url, ...arguments),
    getV2ApiCompanyIdBookkeepingSpainClosurePeriodsPeriodIdDownloadUrl:
      _getV2ApiCompanyIdBookkeepingSpainClosurePeriodsPeriodIdDownloadUrl.bind(
        url,
        ...arguments,
      ),
    postV2ApiCompanyIdBookkeepingSpainClosurePeriodsPeriodIdRetry:
      _postV2ApiCompanyIdBookkeepingSpainClosurePeriodsPeriodIdRetry.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdBudgetDefinitions:
      _getV2ApiCompanyIdBudgetDefinitions.bind(url, ...arguments),
    postV2ApiCompanyIdBudgetDefinitions:
      _postV2ApiCompanyIdBudgetDefinitions.bind(url, ...arguments),
    deleteV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId:
      _deleteV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId:
      _getV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId.bind(
        url,
        ...arguments,
      ),
    putV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId:
      _putV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdBreakdowns:
      _getV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdBreakdowns.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdSpendings:
      _getV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionIdSpendings.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdCardsFailedTransactions:
      _getV2ApiCompanyIdCardsFailedTransactions.bind(url, ...arguments),
    postV2ApiCompanyIdCardsIncreaseLimitsRequest:
      _postV2ApiCompanyIdCardsIncreaseLimitsRequest.bind(url, ...arguments),
    getV2ApiCompanyIdCardsIncreaseLimitsStatus:
      _getV2ApiCompanyIdCardsIncreaseLimitsStatus.bind(url, ...arguments),
    postV2ApiCompanyIdCardsIncreaseLimitsProcedureId:
      _postV2ApiCompanyIdCardsIncreaseLimitsProcedureId.bind(url, ...arguments),
    getV2ApiCompanyIdCardsInvoicesInvoiceRequestIdCardPaymentEligibility:
      _getV2ApiCompanyIdCardsInvoicesInvoiceRequestIdCardPaymentEligibility.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdCardsInvoicesPayableIdInvoiceDetails:
      _getV2ApiCompanyIdCardsInvoicesPayableIdInvoiceDetails.bind(
        url,
        ...arguments,
      ),
    postV2ApiCompanyIdCardsPanShow: _postV2ApiCompanyIdCardsPanShow.bind(
      url,
      ...arguments,
    ),
    postV2ApiCompanyIdCardsPinShow: _postV2ApiCompanyIdCardsPinShow.bind(
      url,
      ...arguments,
    ),
    postV2ApiCompanyIdCardsPinProcedureId:
      _postV2ApiCompanyIdCardsPinProcedureId.bind(url, ...arguments),
    getV2ApiCompanyIdCardsSinglePurchase:
      _getV2ApiCompanyIdCardsSinglePurchase.bind(url, ...arguments),
    getV2ApiCompanyIdCardsSinglePurchaseRequestId:
      _getV2ApiCompanyIdCardsSinglePurchaseRequestId.bind(url, ...arguments),
    getV2ApiCompanyIdCardsTransactionsTransactionId:
      _getV2ApiCompanyIdCardsTransactionsTransactionId.bind(url, ...arguments),
    getV2ApiCompanyIdCardsCardIdAggregatedActivity:
      _getV2ApiCompanyIdCardsCardIdAggregatedActivity.bind(url, ...arguments),
    postV2ApiCompanyIdCardsCardIdPanProcedureId:
      _postV2ApiCompanyIdCardsCardIdPanProcedureId.bind(url, ...arguments),
    getV2ApiCompanyIdCardsCardProductRegulatoryLimits:
      _getV2ApiCompanyIdCardsCardProductRegulatoryLimits.bind(
        url,
        ...arguments,
      ),
    deleteV2ApiCompanyIdCustomFieldsCustomFieldIdValues:
      _deleteV2ApiCompanyIdCustomFieldsCustomFieldIdValues.bind(
        url,
        ...arguments,
      ),
    postV2ApiCompanyIdInternationalTransfersBusinessProfiles:
      _postV2ApiCompanyIdInternationalTransfersBusinessProfiles.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdInternationalTransfersBusinessRepresentatives:
      _getV2ApiCompanyIdInternationalTransfersBusinessRepresentatives.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdInternationalTransfersDeliveryEstimateTimeTransferId:
      _getV2ApiCompanyIdInternationalTransfersDeliveryEstimateTimeTransferId.bind(
        url,
        ...arguments,
      ),
    postV2ApiCompanyIdInternationalTransfersKycReviews:
      _postV2ApiCompanyIdInternationalTransfersKycReviews.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdInternationalTransfersKycStatus:
      _getV2ApiCompanyIdInternationalTransfersKycStatus.bind(url, ...arguments),
    postV2ApiCompanyIdInternationalTransfersQuotes:
      _postV2ApiCompanyIdInternationalTransfersQuotes.bind(url, ...arguments),
    patchV2ApiCompanyIdInternationalTransfersQuotesId:
      _patchV2ApiCompanyIdInternationalTransfersQuotesId.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdInternationalTransfersRecipientRequirements:
      _getV2ApiCompanyIdInternationalTransfersRecipientRequirements.bind(
        url,
        ...arguments,
      ),
    postV2ApiCompanyIdInternationalTransfersRecipientRequirements:
      _postV2ApiCompanyIdInternationalTransfersRecipientRequirements.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdInternationalTransfersRecipients:
      _getV2ApiCompanyIdInternationalTransfersRecipients.bind(
        url,
        ...arguments,
      ),
    postV2ApiCompanyIdInternationalTransfersRecipients:
      _postV2ApiCompanyIdInternationalTransfersRecipients.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdInternationalTransfersRecipientsId:
      _getV2ApiCompanyIdInternationalTransfersRecipientsId.bind(
        url,
        ...arguments,
      ),
    postV2ApiCompanyIdInternationalTransfersTransferRequirements:
      _postV2ApiCompanyIdInternationalTransfersTransferRequirements.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdInternationalTransfersTransferId:
      _getV2ApiCompanyIdInternationalTransfersTransferId.bind(
        url,
        ...arguments,
      ),
    postV2ApiCompanyIdInternationalTransfersValidateRecipient:
      _postV2ApiCompanyIdInternationalTransfersValidateRecipient.bind(
        url,
        ...arguments,
      ),
    postV2ApiCompanyIdInvoiceRequestsLineItemsMatching:
      _postV2ApiCompanyIdInvoiceRequestsLineItemsMatching.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdPaymentsPaymentIdExpenseBeneficiaries:
      _getV2ApiCompanyIdPaymentsPaymentIdExpenseBeneficiaries.bind(
        url,
        ...arguments,
      ),
    putV2ApiCompanyIdPaymentsPaymentIdExpenseBeneficiaries:
      _putV2ApiCompanyIdPaymentsPaymentIdExpenseBeneficiaries.bind(
        url,
        ...arguments,
      ),
    postV2ApiCompanyIdPurchaseOrdersExtraction:
      _postV2ApiCompanyIdPurchaseOrdersExtraction.bind(url, ...arguments),
    getV2ApiCompanyIdPurchaseOrdersSettings:
      _getV2ApiCompanyIdPurchaseOrdersSettings.bind(url, ...arguments),
    putV2ApiCompanyIdPurchaseOrdersSettings:
      _putV2ApiCompanyIdPurchaseOrdersSettings.bind(url, ...arguments),
    postV2ApiCompanyIdPurchaseOrdersPurchaseOrderId:
      _postV2ApiCompanyIdPurchaseOrdersPurchaseOrderId.bind(url, ...arguments),
    putV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdDocument:
      _putV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdDocument.bind(
        url,
        ...arguments,
      ),
    postV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdQuote:
      _postV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdQuote.bind(
        url,
        ...arguments,
      ),
    deleteV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdQuotesQuoteId:
      _deleteV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdQuotesQuoteId.bind(
        url,
        ...arguments,
      ),
    postV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdSendEmailToSupplier:
      _postV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdSendEmailToSupplier.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdThreeWayMatchLinesSummary:
      _getV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdThreeWayMatchLinesSummary.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotes:
      _getV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotes.bind(
        url,
        ...arguments,
      ),
    postV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotes:
      _postV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotes.bind(
        url,
        ...arguments,
      ),
    putV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesExpected:
      _putV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesExpected.bind(
        url,
        ...arguments,
      ),
    deleteV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteId:
      _deleteV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteId.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteId:
      _getV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteId.bind(
        url,
        ...arguments,
      ),
    putV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteId:
      _putV2ApiCompanyIdPurchaseOrdersRequestIdDeliveryNotesDeliveryNoteId.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdPurchaseOrdersRequestIdQuantityDelivered:
      _getV2ApiCompanyIdPurchaseOrdersRequestIdQuantityDelivered.bind(
        url,
        ...arguments,
      ),
    postV2ApiCompanyIdRequestsApprovals:
      _postV2ApiCompanyIdRequestsApprovals.bind(url, ...arguments),
    postV2ApiCompanyIdRequestsDenials: _postV2ApiCompanyIdRequestsDenials.bind(
      url,
      ...arguments,
    ),
    getV2ApiCompanyIdRequestsDraft: _getV2ApiCompanyIdRequestsDraft.bind(
      url,
      ...arguments,
    ),
    postV2ApiCompanyIdRequestsDraftsSubmits:
      _postV2ApiCompanyIdRequestsDraftsSubmits.bind(url, ...arguments),
    postV2ApiCompanyIdRequestsMileage: _postV2ApiCompanyIdRequestsMileage.bind(
      url,
      ...arguments,
    ),
    postV2ApiCompanyIdRequestsMileageComputation:
      _postV2ApiCompanyIdRequestsMileageComputation.bind(url, ...arguments),
    getV2ApiCompanyIdRequestsToApprove:
      _getV2ApiCompanyIdRequestsToApprove.bind(url, ...arguments),
    getV2ApiCompanyIdRequestsRequestId:
      _getV2ApiCompanyIdRequestsRequestId.bind(url, ...arguments),
    putV2ApiCompanyIdRequestsRequestIdDraft:
      _putV2ApiCompanyIdRequestsRequestIdDraft.bind(url, ...arguments),
    getV2ApiCompanyIdRequestsRequestIdExpenseBeneficiaries:
      _getV2ApiCompanyIdRequestsRequestIdExpenseBeneficiaries.bind(
        url,
        ...arguments,
      ),
    putV2ApiCompanyIdRequestsRequestIdExpenseBeneficiaries:
      _putV2ApiCompanyIdRequestsRequestIdExpenseBeneficiaries.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdSpendLimitStatus: _getV2ApiCompanyIdSpendLimitStatus.bind(
      url,
      ...arguments,
    ),
    getV2ApiCompanyIdSpendLimitStatusByRequestRequestId:
      _getV2ApiCompanyIdSpendLimitStatusByRequestRequestId.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdSpendLimits: _getV2ApiCompanyIdSpendLimits.bind(
      url,
      ...arguments,
    ),
    postV2ApiCompanyIdSpendLimits: _postV2ApiCompanyIdSpendLimits.bind(
      url,
      ...arguments,
    ),
    deleteV2ApiCompanyIdSpendLimitsSpendLimitId:
      _deleteV2ApiCompanyIdSpendLimitsSpendLimitId.bind(url, ...arguments),
    getV2ApiCompanyIdSpendLimitsSpendLimitId:
      _getV2ApiCompanyIdSpendLimitsSpendLimitId.bind(url, ...arguments),
    putV2ApiCompanyIdSpendLimitsSpendLimitId:
      _putV2ApiCompanyIdSpendLimitsSpendLimitId.bind(url, ...arguments),
    patchV2ApiCompanyIdTransferSchedulingBillsBillId:
      _patchV2ApiCompanyIdTransferSchedulingBillsBillId.bind(url, ...arguments),
    getV2ApiCompanyIdUserDelegationsDelegatees:
      _getV2ApiCompanyIdUserDelegationsDelegatees.bind(url, ...arguments),
    putV2ApiCompanyIdUserDelegationsDelegatees:
      _putV2ApiCompanyIdUserDelegationsDelegatees.bind(url, ...arguments),
    getV2ApiCompanyIdUserDelegationsDelegators:
      _getV2ApiCompanyIdUserDelegationsDelegators.bind(url, ...arguments),
    postV2ApiCompanyIdUsersManagerAssociations:
      _postV2ApiCompanyIdUsersManagerAssociations.bind(url, ...arguments),
    getV2ApiCompanyIdUsersUserIdAuthenticationFactors:
      _getV2ApiCompanyIdUsersUserIdAuthenticationFactors.bind(
        url,
        ...arguments,
      ),
    postV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryInitiate:
      _postV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryInitiate.bind(
        url,
        ...arguments,
      ),
    postV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryProcedureIdVerify:
      _postV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryProcedureIdVerify.bind(
        url,
        ...arguments,
      ),
    postV2ApiCompanyIdUsersUserIdManagerAssociations:
      _postV2ApiCompanyIdUsersUserIdManagerAssociations.bind(url, ...arguments),
    postV2ApiCompanyIdVerificationsOfPayees:
      _postV2ApiCompanyIdVerificationsOfPayees.bind(url, ...arguments),
    getV2ApiCompanyIdWalletClosedLoopAccounts:
      _getV2ApiCompanyIdWalletClosedLoopAccounts.bind(url, ...arguments),
    postV2ApiCompanyIdWalletWithdrawals:
      _postV2ApiCompanyIdWalletWithdrawals.bind(url, ...arguments),
    getV2ApiCompanyIdWalletWithdrawalsWithdrawalIdStatus:
      _getV2ApiCompanyIdWalletWithdrawalsWithdrawalIdStatus.bind(
        url,
        ...arguments,
      ),
    getV2ApiOrganisationIdSettings: _getV2ApiOrganisationIdSettings.bind(
      url,
      ...arguments,
    ),
    postV2ApiOrganisationIdSettings: _postV2ApiOrganisationIdSettings.bind(
      url,
      ...arguments,
    ),
    getV2ApiOrganisationIdSettingsAccess:
      _getV2ApiOrganisationIdSettingsAccess.bind(url, ...arguments),
    postV2ApiOrganisationIdSettingsBulkDelete:
      _postV2ApiOrganisationIdSettingsBulkDelete.bind(url, ...arguments),
    postV2ApiOrganisationIdSettingsMerge:
      _postV2ApiOrganisationIdSettingsMerge.bind(url, ...arguments),
    postV2ApiOrganisationIdSettingsMigrate:
      _postV2ApiOrganisationIdSettingsMigrate.bind(url, ...arguments),
    deleteV2ApiOrganisationIdSettingsSettingsId:
      _deleteV2ApiOrganisationIdSettingsSettingsId.bind(url, ...arguments),
    patchV2ApiOrganisationIdSettingsSettingsId:
      _patchV2ApiOrganisationIdSettingsSettingsId.bind(url, ...arguments),
    getV2HealthCheck: _getV2HealthCheck.bind(url, ...arguments),
    postV2ApiCompanyIdTravelPropertiesAccommodationSuggestions:
      _postV2ApiCompanyIdTravelPropertiesAccommodationSuggestions.bind(
        url,
        ...arguments,
      ),
    postV2ApiCompanyIdTravelPropertiesSearch:
      _postV2ApiCompanyIdTravelPropertiesSearch.bind(url, ...arguments),
    getV2ApiCompanyIdTravelPropertiesSessionSessionIdResults:
      _getV2ApiCompanyIdTravelPropertiesSessionSessionIdResults.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdTravelPropertiesPropertyOfferIdOffers:
      _getV2ApiCompanyIdTravelPropertiesPropertyOfferIdOffers.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdTravelTrips: _getV2ApiCompanyIdTravelTrips.bind(
      url,
      ...arguments,
    ),
    postV2ApiCompanyIdTravelTrips: _postV2ApiCompanyIdTravelTrips.bind(
      url,
      ...arguments,
    ),
    getV2ApiCompanyIdTravelTripsCurrent:
      _getV2ApiCompanyIdTravelTripsCurrent.bind(url, ...arguments),
    getV2ApiCompanyIdTravelTripsTripId:
      _getV2ApiCompanyIdTravelTripsTripId.bind(url, ...arguments),
    postV2ApiCompanyIdTravelTripsTripIdBookingsProperty:
      _postV2ApiCompanyIdTravelTripsTripIdBookingsProperty.bind(
        url,
        ...arguments,
      ),
    deleteV2ApiCompanyIdTravelTripsTripIdBookingsBookingId:
      _deleteV2ApiCompanyIdTravelTripsTripIdBookingsBookingId.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdTravelTripsTripIdBookingsBookingIdProperty:
      _getV2ApiCompanyIdTravelTripsTripIdBookingsBookingIdProperty.bind(
        url,
        ...arguments,
      ),
    getV2ApiCompanyIdTravelTripsTripIdPayments:
      _getV2ApiCompanyIdTravelTripsTripIdPayments.bind(url, ...arguments),
    postV2ApiCompanyIdTravelTripsTripIdPayments:
      _postV2ApiCompanyIdTravelTripsTripIdPayments.bind(url, ...arguments),
    deleteV2ApiCompanyIdTravelEntityTypeEntityIdTrip:
      _deleteV2ApiCompanyIdTravelEntityTypeEntityIdTrip.bind(url, ...arguments),
    getV2ApiCompanyIdTravelEntityTypeEntityIdTrip:
      _getV2ApiCompanyIdTravelEntityTypeEntityIdTrip.bind(url, ...arguments),
    putV2ApiCompanyIdTravelEntityTypeEntityIdTripTripId:
      _putV2ApiCompanyIdTravelEntityTypeEntityIdTripTripId.bind(
        url,
        ...arguments,
      ),
  };
}
